"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (f) {
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (typeof define === "function" && define.amd) {
    define([], f);
  } else {
    var g;if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }g.mapstylergl = f();
  }
})(function () {
  var define, module, exports;return function () {
    function r(e, n, t) {
      function o(i, f) {
        if (!n[i]) {
          if (!e[i]) {
            var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
          }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
            var n = e[i][1][r];return o(n || r);
          }, p, p.exports, r, e, n, t);
        }return n[i].exports;
      }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
        o(t[i]);
      }return o;
    }return r;
  }()({ 1: [function (_dereq_, module, exports) {
      function Extent(t) {
        if (!(this instanceof Extent)) return new Extent(t);this._bbox = t || [1 / 0, 1 / 0, -1 / 0, -1 / 0], this._valid = !!t;
      }module.exports = Extent, Extent.prototype.include = function (t) {
        return this._valid = !0, this._bbox[0] = Math.min(this._bbox[0], t[0]), this._bbox[1] = Math.min(this._bbox[1], t[1]), this._bbox[2] = Math.max(this._bbox[2], t[0]), this._bbox[3] = Math.max(this._bbox[3], t[1]), this;
      }, Extent.prototype.equals = function (t) {
        var b;return b = t instanceof Extent ? t.bbox() : t, this._bbox[0] == b[0] && this._bbox[1] == b[1] && this._bbox[2] == b[2] && this._bbox[3] == b[3];
      }, Extent.prototype.center = function (t) {
        return this._valid ? [(this._bbox[0] + this._bbox[2]) / 2, (this._bbox[1] + this._bbox[3]) / 2] : null;
      }, Extent.prototype.union = function (t) {
        this._valid = !0;var b;return b = t instanceof Extent ? t.bbox() : t, this._bbox[0] = Math.min(this._bbox[0], b[0]), this._bbox[1] = Math.min(this._bbox[1], b[1]), this._bbox[2] = Math.max(this._bbox[2], b[2]), this._bbox[3] = Math.max(this._bbox[3], b[3]), this;
      }, Extent.prototype.bbox = function () {
        return this._valid ? this._bbox : null;
      }, Extent.prototype.contains = function (t) {
        if (!t) return this._fastContains();if (!this._valid) return null;var b = t[0],
            i = t[1];return this._bbox[0] <= b && this._bbox[1] <= i && this._bbox[2] >= b && this._bbox[3] >= i;
      }, Extent.prototype.intersect = function (t) {
        if (!this._valid) return null;var b;return b = t instanceof Extent ? t.bbox() : t, !(this._bbox[0] > b[2] || this._bbox[2] < b[0] || this._bbox[3] < b[1] || this._bbox[1] > b[3]);
      }, Extent.prototype._fastContains = function () {
        if (!this._valid) return new Function("return null;");var t = "return " + this._bbox[0] + "<= ll[0] &&" + this._bbox[1] + "<= ll[1] &&" + this._bbox[2] + ">= ll[0] &&" + this._bbox[3] + ">= ll[1]";return new Function("ll", t);
      }, Extent.prototype.polygon = function () {
        return this._valid ? { type: "Polygon", coordinates: [[[this._bbox[0], this._bbox[1]], [this._bbox[2], this._bbox[1]], [this._bbox[2], this._bbox[3]], [this._bbox[0], this._bbox[3]], [this._bbox[0], this._bbox[1]]]] } : null;
      };
    }, {}], 2: [function (_dereq_, module, exports) {
      module.exports = function (r) {
        function n(r) {
          return Array.isArray(r) && r.length && "number" == typeof r[0] ? [r] : r.reduce(function (r, e) {
            return Array.isArray(e) && Array.isArray(e[0]) ? r.concat(n(e)) : (r.push(e), r);
          }, []);
        }return n(r);
      };
    }, {}], 3: [function (_dereq_, module, exports) {
      var geojsonNormalize = _dereq_("@mapbox/geojson-normalize"),
          geojsonFlatten = _dereq_("geojson-flatten"),
          flatten = _dereq_("./flatten");module.exports = function (e) {
        if (!e) return [];var o = geojsonFlatten(geojsonNormalize(e)),
            t = [];return o.features.forEach(function (e) {
          e.geometry && (t = t.concat(flatten(e.geometry.coordinates)));
        }), t;
      };
    }, { "./flatten": 2, "@mapbox/geojson-normalize": 5, "geojson-flatten": 9 }], 4: [function (_dereq_, module, exports) {
      function getExtent(e) {
        for (var t = extent(), o = geojsonCoords(e), n = 0; n < o.length; n++) {
          t.include(o[n]);
        }return t;
      }var geojsonCoords = _dereq_("@mapbox/geojson-coords"),
          traverse = _dereq_("traverse"),
          extent = _dereq_("@mapbox/extent"),
          geojsonTypesByDataAttributes = { features: ["FeatureCollection"], coordinates: ["Point", "MultiPoint", "LineString", "MultiLineString", "Polygon", "MultiPolygon"], geometry: ["Feature"], geometries: ["GeometryCollection"] },
          dataAttributes = Object.keys(geojsonTypesByDataAttributes);module.exports = function (e) {
        return getExtent(e).bbox();
      }, module.exports.polygon = function (e) {
        return getExtent(e).polygon();
      }, module.exports.bboxify = function (e) {
        return traverse(e).map(function (e) {
          if (e) {
            dataAttributes.some(function (t) {
              return !!e[t] && -1 !== geojsonTypesByDataAttributes[t].indexOf(e.type);
            }) && (e.bbox = getExtent(e).bbox(), this.update(e));
          }
        });
      };
    }, { "@mapbox/extent": 1, "@mapbox/geojson-coords": 3, "traverse": 27 }], 5: [function (_dereq_, module, exports) {
      function normalize(e) {
        if (!e || !e.type) return null;var t = types[e.type];return t ? "geometry" === t ? { type: "FeatureCollection", features: [{ type: "Feature", properties: {}, geometry: e }] } : "feature" === t ? { type: "FeatureCollection", features: [e] } : "featurecollection" === t ? e : void 0 : null;
      }module.exports = normalize;var types = { Point: "geometry", MultiPoint: "geometry", LineString: "geometry", MultiLineString: "geometry", Polygon: "geometry", MultiPolygon: "geometry", GeometryCollection: "geometry", Feature: "feature", FeatureCollection: "featurecollection" };
    }, {}], 6: [function (_dereq_, module, exports) {
      "use strict";
      function throwFirstError() {
        if (pendingErrors.length) throw pendingErrors.shift();
      }function asap(r) {
        var s;s = freeTasks.length ? freeTasks.pop() : new RawTask(), s.task = r, rawAsap(s);
      }function RawTask() {
        this.task = null;
      }var rawAsap = _dereq_("./raw"),
          freeTasks = [],
          pendingErrors = [],
          requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);module.exports = asap, RawTask.prototype.call = function () {
        try {
          this.task.call();
        } catch (r) {
          asap.onerror ? asap.onerror(r) : (pendingErrors.push(r), requestErrorThrow());
        } finally {
          this.task = null, freeTasks[freeTasks.length] = this;
        }
      };
    }, { "./raw": 7 }], 7: [function (_dereq_, module, exports) {
      (function (global) {
        "use strict";
        function rawAsap(e) {
          queue.length || (requestFlush(), flushing = !0), queue[queue.length] = e;
        }function flush() {
          for (; index < queue.length;) {
            var e = index;if (index += 1, queue[e].call(), index > capacity) {
              for (var u = 0, t = queue.length - index; u < t; u++) {
                queue[u] = queue[u + index];
              }queue.length -= index, index = 0;
            }
          }queue.length = 0, index = 0, flushing = !1;
        }function makeRequestCallFromMutationObserver(e) {
          var u = 1,
              t = new BrowserMutationObserver(e),
              r = document.createTextNode("");return t.observe(r, { characterData: !0 }), function () {
            u = -u, r.data = u;
          };
        }function makeRequestCallFromTimer(e) {
          return function () {
            function u() {
              clearTimeout(t), clearInterval(r), e();
            }var t = setTimeout(u, 0),
                r = setInterval(u, 50);
          };
        }module.exports = rawAsap;var queue = [],
            flushing = !1,
            requestFlush,
            index = 0,
            capacity = 1024,
            scope = "undefined" != typeof global ? global : self,
            BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;requestFlush = "function" == typeof BrowserMutationObserver ? makeRequestCallFromMutationObserver(flush) : makeRequestCallFromTimer(flush), rawAsap.requestFlush = requestFlush, rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, {}], 8: [function (_dereq_, module, exports) {
      (function () {
        var e,
            n,
            r,
            t,
            f,
            a,
            u,
            c,
            o,
            l,
            i,
            s,
            b,
            d,
            _h,
            _p,
            g,
            m,
            v,
            y,
            w,
            k,
            _,
            N,
            M,
            x,
            A,
            O,
            j,
            q,
            G,
            L,
            P,
            B,
            R,
            Y,
            E,
            S,
            X,
            z,
            U,
            V,
            C,
            F,
            I,
            K,
            Z,
            D,
            $,
            H,
            J,
            Q,
            T,
            W,
            ee,
            ne,
            re,
            te,
            fe,
            ae,
            ue,
            ce,
            oe,
            le,
            ie,
            se,
            be,
            de,
            he,
            pe,
            ge,
            ve,
            ye,
            we,
            ke,
            _e,
            Ne,
            Me,
            xe,
            Ae,
            Oe,
            je,
            qe = [].slice;Me = function () {
          var e, n, r, t, f;for (e = {}, f = "Boolean Number String Function Array Date RegExp Undefined Null".split(" "), t = 0, n = f.length; t < n; t++) {
            r = f[t], e["[object " + r + "]"] = r.toLowerCase();
          }return function (n) {
            var r;return r = Object.prototype.toString.call(n), e[r] || "object";
          };
        }(), Z = function Z(e, n, r) {
          return null == n && (n = 0), null == r && (r = 1), e < n && (e = n), e > r && (e = r), e;
        }, xe = function xe(e) {
          return e.length >= 3 ? [].slice.call(e) : e[0];
        }, w = function w(e) {
          var n, r;for (e._clipped = !1, e._unclipped = e.slice(0), n = r = 0; r < 3; n = ++r) {
            n < 3 ? ((e[n] < 0 || e[n] > 255) && (e._clipped = !0), e[n] < 0 && (e[n] = 0), e[n] > 255 && (e[n] = 255)) : 3 === n && (e[n] < 0 && (e[n] = 0), e[n] > 1 && (e[n] = 1));
          }return e._clipped || delete e._unclipped, e;
        }, t = Math.PI, ye = Math.round, _ = Math.cos, O = Math.floor, ne = Math.pow, D = Math.log, ke = Math.sin, _e = Math.sqrt, d = Math.atan2, J = Math.max, b = Math.abs, u = 2 * t, f = t / 3, n = t / 180, a = 180 / t, y = function y() {
          return arguments[0] instanceof e ? arguments[0] : function (e, n, r) {
            r.prototype = e.prototype;var t = new r(),
                f = e.apply(t, n);return Object(f) === f ? f : t;
          }(e, arguments, function () {});
        }, y.default = y, s = [], "undefined" != typeof module && null !== module && null != module.exports && (module.exports = y), "function" == typeof define && define.amd ? define([], function () {
          return y;
        }) : (ve = "undefined" != typeof exports && null !== exports ? exports : this, ve.chroma = y), y.version = "1.3.5", i = {}, o = [], l = !1, e = function () {
          function e() {
            var e, n, r, t, f, a, u, c, s;for (a = this, n = [], c = 0, t = arguments.length; c < t; c++) {
              null != (e = arguments[c]) && n.push(e);
            }if (n.length > 1 && (u = n[n.length - 1]), null != i[u]) a._rgb = w(i[u](xe(n.slice(0, -1))));else {
              for (l || (o = o.sort(function (e, n) {
                return n.p - e.p;
              }), l = !0), s = 0, f = o.length; s < f && (r = o[s], !(u = r.test.apply(r, n))); s++) {}u && (a._rgb = w(i[u].apply(i, n)));
            }null == a._rgb && console.warn("unknown format: " + n), null == a._rgb && (a._rgb = [0, 0, 0]), 3 === a._rgb.length && a._rgb.push(1);
          }return e.prototype.toString = function () {
            return this.hex();
          }, e.prototype.clone = function () {
            return y(me._rgb);
          }, e;
        }(), y._input = i, y.brewer = m = { OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"], PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"], BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"], Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"], BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"], YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"], YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"], Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"], RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"], Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"], YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"], Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"], GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"], Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"], YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"], PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"], Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"], PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"], Viridis: ["#440154", "#482777", "#3f4a8a", "#31678e", "#26838f", "#1f9d8a", "#6cce5a", "#b6de2b", "#fee825"], Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"], RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"], RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"], PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"], PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"], RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"], BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"], RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"], PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"], Set2: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"], Accent: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"], Set1: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"], Set3: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"], Dark2: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"], Paired: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"], Pastel2: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"], Pastel1: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"] }, function () {
          var e, n;n = [];for (e in m) {
            n.push(m[e.toLowerCase()] = m[e]);
          }
        }(), Ae = { aliceblue: "#f0f8ff", antiquewhite: "#faebd7", aqua: "#00ffff", aquamarine: "#7fffd4", azure: "#f0ffff", beige: "#f5f5dc", bisque: "#ffe4c4", black: "#000000", blanchedalmond: "#ffebcd", blue: "#0000ff", blueviolet: "#8a2be2", brown: "#a52a2a", burlywood: "#deb887", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", cornflower: "#6495ed", cornflowerblue: "#6495ed", cornsilk: "#fff8dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", darkkhaki: "#bdb76b", darkmagenta: "#8b008b", darkolivegreen: "#556b2f", darkorange: "#ff8c00", darkorchid: "#9932cc", darkred: "#8b0000", darksalmon: "#e9967a", darkseagreen: "#8fbc8f", darkslateblue: "#483d8b", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", darkturquoise: "#00ced1", darkviolet: "#9400d3", deeppink: "#ff1493", deepskyblue: "#00bfff", dimgray: "#696969", dimgrey: "#696969", dodgerblue: "#1e90ff", firebrick: "#b22222", floralwhite: "#fffaf0", forestgreen: "#228b22", fuchsia: "#ff00ff", gainsboro: "#dcdcdc", ghostwhite: "#f8f8ff", gold: "#ffd700", goldenrod: "#daa520", gray: "#808080", green: "#008000", greenyellow: "#adff2f", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", indianred: "#cd5c5c", indigo: "#4b0082", ivory: "#fffff0", khaki: "#f0e68c", laserlemon: "#ffff54", lavender: "#e6e6fa", lavenderblush: "#fff0f5", lawngreen: "#7cfc00", lemonchiffon: "#fffacd", lightblue: "#add8e6", lightcoral: "#f08080", lightcyan: "#e0ffff", lightgoldenrod: "#fafad2", lightgoldenrodyellow: "#fafad2", lightgray: "#d3d3d3", lightgreen: "#90ee90", lightgrey: "#d3d3d3", lightpink: "#ffb6c1", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", lightskyblue: "#87cefa", lightslategray: "#778899", lightslategrey: "#778899", lightsteelblue: "#b0c4de", lightyellow: "#ffffe0", lime: "#00ff00", limegreen: "#32cd32", linen: "#faf0e6", magenta: "#ff00ff", maroon: "#800000", maroon2: "#7f0000", maroon3: "#b03060", mediumaquamarine: "#66cdaa", mediumblue: "#0000cd", mediumorchid: "#ba55d3", mediumpurple: "#9370db", mediumseagreen: "#3cb371", mediumslateblue: "#7b68ee", mediumspringgreen: "#00fa9a", mediumturquoise: "#48d1cc", mediumvioletred: "#c71585", midnightblue: "#191970", mintcream: "#f5fffa", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", navajowhite: "#ffdead", navy: "#000080", oldlace: "#fdf5e6", olive: "#808000", olivedrab: "#6b8e23", orange: "#ffa500", orangered: "#ff4500", orchid: "#da70d6", palegoldenrod: "#eee8aa", palegreen: "#98fb98", paleturquoise: "#afeeee", palevioletred: "#db7093", papayawhip: "#ffefd5", peachpuff: "#ffdab9", peru: "#cd853f", pink: "#ffc0cb", plum: "#dda0dd", powderblue: "#b0e0e6", purple: "#800080", purple2: "#7f007f", purple3: "#a020f0", rebeccapurple: "#663399", red: "#ff0000", rosybrown: "#bc8f8f", royalblue: "#4169e1", saddlebrown: "#8b4513", salmon: "#fa8072", sandybrown: "#f4a460", seagreen: "#2e8b57", seashell: "#fff5ee", sienna: "#a0522d", silver: "#c0c0c0", skyblue: "#87ceeb", slateblue: "#6a5acd", slategray: "#708090", slategrey: "#708090", snow: "#fffafa", springgreen: "#00ff7f", steelblue: "#4682b4", tan: "#d2b48c", teal: "#008080", thistle: "#d8bfd8", tomato: "#ff6347", turquoise: "#40e0d0", violet: "#ee82ee", wheat: "#f5deb3", white: "#ffffff", whitesmoke: "#f5f5f5", yellow: "#ffff00", yellowgreen: "#9acd32" }, y.colors = Ae, V = function V() {
          var e, n, t, f, a, u, c, o, l;return n = xe(arguments), a = n[0], e = n[1], t = n[2], o = (a + 16) / 116, c = isNaN(e) ? o : o + e / 500, l = isNaN(t) ? o : o - t / 200, o = r.Yn * C(o), c = r.Xn * C(c), l = r.Zn * C(l), u = je(3.2404542 * c - 1.5371385 * o - .4985314 * l), f = je(-.969266 * c + 1.8760108 * o + .041556 * l), t = je(.0556434 * c - .2040259 * o + 1.0572252 * l), [u, f, t, n.length > 3 ? n[3] : 1];
        }, je = function je(e) {
          return 255 * (e <= .00304 ? 12.92 * e : 1.055 * ne(e, 1 / 2.4) - .055);
        }, C = function C(e) {
          return e > r.t1 ? e * e * e : r.t2 * (e - r.t0);
        }, r = { Kn: 18, Xn: .95047, Yn: 1, Zn: 1.08883, t0: .137931034, t1: .206896552, t2: .12841855, t3: .008856452 }, le = function le() {
          var e, n, r, t, f, a, u, c;return t = xe(arguments), r = t[0], n = t[1], e = t[2], f = he(r, n, e), a = f[0], u = f[1], c = f[2], [116 * u - 16, 500 * (a - u), 200 * (u - c)];
        }, pe = function pe(e) {
          return (e /= 255) <= .04045 ? e / 12.92 : ne((e + .055) / 1.055, 2.4);
        }, Oe = function Oe(e) {
          return e > r.t3 ? ne(e, 1 / 3) : e / r.t2 + r.t0;
        }, he = function he() {
          var e, n, t, f, a, u, c;return f = xe(arguments), t = f[0], n = f[1], e = f[2], t = pe(t), n = pe(n), e = pe(e), a = Oe((.4124564 * t + .3575761 * n + .1804375 * e) / r.Xn), u = Oe((.2126729 * t + .7151522 * n + .072175 * e) / r.Yn), c = Oe((.0193339 * t + .119192 * n + .9503041 * e) / r.Zn), [a, u, c];
        }, y.lab = function () {
          return function (e, n, r) {
            r.prototype = e.prototype;var t = new r(),
                f = e.apply(t, n);return Object(f) === f ? f : t;
          }(e, qe.call(arguments).concat(["lab"]), function () {});
        }, i.lab = V, e.prototype.lab = function () {
          return le(this._rgb);
        }, _h = function h(e) {
          var n, r, t, f, a, u, c, o, l, i, s;return e = function () {
            var n, r, t;for (t = [], r = 0, n = e.length; r < n; r++) {
              f = e[r], t.push(y(f));
            }return t;
          }(), 2 === e.length ? (l = function () {
            var n, r, t;for (t = [], r = 0, n = e.length; r < n; r++) {
              f = e[r], t.push(f.lab());
            }return t;
          }(), a = l[0], u = l[1], n = function n(e) {
            var n, r;return r = function () {
              var r, t;for (t = [], n = r = 0; r <= 2; n = ++r) {
                t.push(a[n] + e * (u[n] - a[n]));
              }return t;
            }(), y.lab.apply(y, r);
          }) : 3 === e.length ? (i = function () {
            var n, r, t;for (t = [], r = 0, n = e.length; r < n; r++) {
              f = e[r], t.push(f.lab());
            }return t;
          }(), a = i[0], u = i[1], c = i[2], n = function n(e) {
            var n, r;return r = function () {
              var r, t;for (t = [], n = r = 0; r <= 2; n = ++r) {
                t.push((1 - e) * (1 - e) * a[n] + 2 * (1 - e) * e * u[n] + e * e * c[n]);
              }return t;
            }(), y.lab.apply(y, r);
          }) : 4 === e.length ? (s = function () {
            var n, r, t;for (t = [], r = 0, n = e.length; r < n; r++) {
              f = e[r], t.push(f.lab());
            }return t;
          }(), a = s[0], u = s[1], c = s[2], o = s[3], n = function n(e) {
            var n, r;return r = function () {
              var r, t;for (t = [], n = r = 0; r <= 2; n = ++r) {
                t.push((1 - e) * (1 - e) * (1 - e) * a[n] + 3 * (1 - e) * (1 - e) * e * u[n] + 3 * (1 - e) * e * e * c[n] + e * e * e * o[n]);
              }return t;
            }(), y.lab.apply(y, r);
          }) : 5 === e.length && (r = _h(e.slice(0, 3)), t = _h(e.slice(2, 5)), n = function n(e) {
            return e < .5 ? r(2 * e) : t(2 * (e - .5));
          }), n;
        }, y.bezier = function (e) {
          var n;return n = _h(e), n.scale = function () {
            return y.scale(n);
          }, n;
        }, y.cubehelix = function (e, n, r, t, f) {
          var a, c, o;return null == e && (e = 300), null == n && (n = -1.5), null == r && (r = 1), null == t && (t = 1), null == f && (f = [0, 1]), a = 0, "array" === Me(f) ? c = f[1] - f[0] : (c = 0, f = [f, f]), o = function o(_o) {
            var l, i, s, b, d, h, p, g, m;return l = u * ((e + 120) / 360 + n * _o), p = ne(f[0] + c * _o, t), h = 0 !== a ? r[0] + _o * a : r, i = h * p * (1 - p) / 2, b = _(l), m = ke(l), g = p + i * (-.14861 * b + 1.78277 * m), d = p + i * (-.29227 * b - .90649 * m), s = p + i * (1.97294 * b), y(w([255 * g, 255 * d, 255 * s]));
          }, o.start = function (n) {
            return null == n ? e : (e = n, o);
          }, o.rotations = function (e) {
            return null == e ? n : (n = e, o);
          }, o.gamma = function (e) {
            return null == e ? t : (t = e, o);
          }, o.hue = function (e) {
            return null == e ? r : (r = e, "array" === Me(r) ? 0 === (a = r[1] - r[0]) && (r = r[1]) : a = 0, o);
          }, o.lightness = function (e) {
            return null == e ? f : ("array" === Me(e) ? (f = e, c = e[1] - e[0]) : (f = [e, e], c = 0), o);
          }, o.scale = function () {
            return y.scale(o);
          }, o.hue(r), o;
        }, y.random = function () {
          var n, r, t;for (r = "0123456789abcdef", n = "#", t = 0; t < 6; ++t) {
            n += r.charAt(O(16 * Math.random()));
          }return new e(n);
        }, s = [], R = function R(e, n, r, t) {
          var f, a, u, c;for (null == r && (r = .5), null == t && (t = "rgb"), "object" !== Me(e) && (e = y(e)), "object" !== Me(n) && (n = y(n)), u = 0, a = s.length; u < a; u++) {
            if (f = s[u], t === f[0]) {
              c = f[1](e, n, r, t);break;
            }
          }if (null == c) throw "color mode " + t + " is not supported";return c.alpha(e.alpha() + r * (n.alpha() - e.alpha()));
        }, y.interpolate = R, e.prototype.interpolate = function (e, n, r) {
          return R(this, e, n, r);
        }, y.mix = R, e.prototype.mix = e.prototype.interpolate, i.rgb = function () {
          var e, n, r, t;n = xe(arguments), r = [];for (e in n) {
            t = n[e], r.push(t);
          }return r;
        }, y.rgb = function () {
          return function (e, n, r) {
            r.prototype = e.prototype;var t = new r(),
                f = e.apply(t, n);return Object(f) === f ? f : t;
          }(e, qe.call(arguments).concat(["rgb"]), function () {});
        }, e.prototype.rgb = function (e) {
          return null == e && (e = !0), e ? this._rgb.map(Math.round).slice(0, 3) : this._rgb.slice(0, 3);
        }, e.prototype.rgba = function (e) {
          return null == e && (e = !0), e ? [Math.round(this._rgb[0]), Math.round(this._rgb[1]), Math.round(this._rgb[2]), this._rgb[3]] : this._rgb.slice(0);
        }, o.push({ p: 3, test: function test(e) {
            var n;return n = xe(arguments), "array" === Me(n) && 3 === n.length ? "rgb" : 4 === n.length && "number" === Me(n[3]) && n[3] >= 0 && n[3] <= 1 ? "rgb" : void 0;
          } }), i.lrgb = i.rgb, S = function S(n, r, t, f) {
          var a, u;return a = n._rgb, u = r._rgb, new e(_e(ne(a[0], 2) * (1 - t) + ne(u[0], 2) * t), _e(ne(a[1], 2) * (1 - t) + ne(u[1], 2) * t), _e(ne(a[2], 2) * (1 - t) + ne(u[2], 2) * t), f);
        }, c = function c(n) {
          var r, t, f, a, u, c;for (t = 1 / n.length, c = [0, 0, 0, 0], a = 0, f = n.length; a < f; a++) {
            r = n[a], u = r._rgb, c[0] += ne(u[0], 2) * t, c[1] += ne(u[1], 2) * t, c[2] += ne(u[2], 2) * t, c[3] += u[3] * t;
          }return c[0] = _e(c[0]), c[1] = _e(c[1]), c[2] = _e(c[2]), new e(c);
        }, s.push(["lrgb", S]), y.average = function (e, n) {
          var r, f, a, u, o, l, i, s, b, h, p, g, m;if (null == n && (n = "rgb"), b = e.length, e = e.map(function (e) {
            return y(e);
          }), i = e.splice(0, 1)[0], "lrgb" === n) return c(e);g = i.get(n), u = [], o = 0, l = 0;for (s in g) {
            g[s] = g[s] || 0, u.push(isNaN(g[s]) ? 0 : 1), "h" !== n.charAt(s) || isNaN(g[s]) || (r = g[s] / 180 * t, o += _(r), l += ke(r));
          }for (f = i.alpha(), p = 0, h = e.length; p < h; p++) {
            a = e[p], m = a.get(n), f += a.alpha();for (s in g) {
              isNaN(m[s]) || (g[s] += m[s], u[s] += 1, "h" === n.charAt(s) && (r = g[s] / 180 * t, o += _(r), l += ke(r)));
            }
          }for (s in g) {
            if (g[s] = g[s] / u[s], "h" === n.charAt(s)) {
              for (r = d(l / u[s], o / u[s]) / t * 180; r < 0;) {
                r += 360;
              }for (; r >= 360;) {
                r -= 360;
              }g[s] = r;
            }
          }return y(g, n).alpha(f / b);
        }, q = function q(e) {
          var n, r, t, f, a, u;if (e.match(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) return 4 !== e.length && 7 !== e.length || (e = e.substr(1)), 3 === e.length && (e = e.split(""), e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]), u = parseInt(e, 16), f = u >> 16, t = u >> 8 & 255, r = 255 & u, [f, t, r, 1];if (e.match(/^#?([A-Fa-f0-9]{8})$/)) return 9 === e.length && (e = e.substr(1)), u = parseInt(e, 16), f = u >> 24 & 255, t = u >> 16 & 255, r = u >> 8 & 255, n = ye((255 & u) / 255 * 100) / 100, [f, t, r, n];if (null != i.css && (a = i.css(e))) return a;throw "unknown color: " + e;
        }, ae = function ae(e, n) {
          var r, t, f, a, u, c, o;return null == n && (n = "rgb"), u = e[0], f = e[1], t = e[2], r = e[3], u = Math.round(u), f = Math.round(f), t = Math.round(t), o = u << 16 | f << 8 | t, c = "000000" + o.toString(16), c = c.substr(c.length - 6), a = "0" + ye(255 * r).toString(16), a = a.substr(a.length - 2), "#" + function () {
            switch (n.toLowerCase()) {case "rgba":
                return c + a;case "argb":
                return a + c;default:
                return c;}
          }();
        }, i.hex = function (e) {
          return q(e);
        }, y.hex = function () {
          return function (e, n, r) {
            r.prototype = e.prototype;var t = new r(),
                f = e.apply(t, n);return Object(f) === f ? f : t;
          }(e, qe.call(arguments).concat(["hex"]), function () {});
        }, e.prototype.hex = function (e) {
          return null == e && (e = "rgb"), ae(this._rgb, e);
        }, o.push({ p: 4, test: function test(e) {
            if (1 === arguments.length && "string" === Me(e)) return "hex";
          } }), P = function P() {
          var e, n, r, t, f, a, u, c, o, l, i, s, b, d;if (e = xe(arguments), f = e[0], i = e[1], u = e[2], 0 === i) o = t = n = 255 * u;else {
            for (d = [0, 0, 0], r = [0, 0, 0], b = u < .5 ? u * (1 + i) : u + i - u * i, s = 2 * u - b, f /= 360, d[0] = f + 1 / 3, d[1] = f, d[2] = f - 1 / 3, a = c = 0; c <= 2; a = ++c) {
              d[a] < 0 && (d[a] += 1), d[a] > 1 && (d[a] -= 1), 6 * d[a] < 1 ? r[a] = s + 6 * (b - s) * d[a] : 2 * d[a] < 1 ? r[a] = b : 3 * d[a] < 2 ? r[a] = s + (b - s) * (2 / 3 - d[a]) * 6 : r[a] = s;
            }l = [ye(255 * r[0]), ye(255 * r[1]), ye(255 * r[2])], o = l[0], t = l[1], n = l[2];
          }return e.length > 3 ? [o, t, n, e[3]] : [o, t, n];
        }, ce = function ce(e, n, r) {
          var t, f, a, u, c;return void 0 !== e && e.length >= 3 && (u = e, e = u[0], n = u[1], r = u[2]), e /= 255, n /= 255, r /= 255, a = Math.min(e, n, r), J = Math.max(e, n, r), f = (J + a) / 2, J === a ? (c = 0, t = Number.NaN) : c = f < .5 ? (J - a) / (J + a) : (J - a) / (2 - J - a), e === J ? t = (n - r) / (J - a) : n === J ? t = 2 + (r - e) / (J - a) : r === J && (t = 4 + (e - n) / (J - a)), t *= 60, t < 0 && (t += 360), [t, c, f];
        }, y.hsl = function () {
          return function (e, n, r) {
            r.prototype = e.prototype;var t = new r(),
                f = e.apply(t, n);return Object(f) === f ? f : t;
          }(e, qe.call(arguments).concat(["hsl"]), function () {});
        }, i.hsl = P, e.prototype.hsl = function () {
          return ce(this._rgb);
        }, B = function B() {
          var e, n, r, t, f, a, u, c, o, l, i, s, b, d, h, p, g, m;if (e = xe(arguments), f = e[0], p = e[1], m = e[2], m *= 255, 0 === p) o = t = n = m;else switch (360 === f && (f = 0), f > 360 && (f -= 360), f < 0 && (f += 360), f /= 60, a = O(f), r = f - a, u = m * (1 - p), c = m * (1 - p * r), g = m * (1 - p * (1 - r)), a) {case 0:
              l = [m, g, u], o = l[0], t = l[1], n = l[2];break;case 1:
              i = [c, m, u], o = i[0], t = i[1], n = i[2];break;case 2:
              s = [u, m, g], o = s[0], t = s[1], n = s[2];break;case 3:
              b = [u, c, m], o = b[0], t = b[1], n = b[2];break;case 4:
              d = [g, u, m], o = d[0], t = d[1], n = d[2];break;case 5:
              h = [m, u, c], o = h[0], t = h[1], n = h[2];}return [o, t, n, e.length > 3 ? e[3] : 1];
        }, oe = function oe() {
          var e, n, r, t, f, a, u, c, o;return u = xe(arguments), a = u[0], r = u[1], e = u[2], f = Math.min(a, r, e), J = Math.max(a, r, e), n = J - f, o = J / 255, 0 === J ? (t = Number.NaN, c = 0) : (c = n / J, a === J && (t = (r - e) / n), r === J && (t = 2 + (e - a) / n), e === J && (t = 4 + (a - r) / n), (t *= 60) < 0 && (t += 360)), [t, c, o];
        }, y.hsv = function () {
          return function (e, n, r) {
            r.prototype = e.prototype;var t = new r(),
                f = e.apply(t, n);return Object(f) === f ? f : t;
          }(e, qe.call(arguments).concat(["hsv"]), function () {});
        }, i.hsv = B, e.prototype.hsv = function () {
          return oe(this._rgb);
        }, W = function W(e) {
          var n, r, t;return "number" === Me(e) && e >= 0 && e <= 16777215 ? (t = e >> 16, r = e >> 8 & 255, n = 255 & e, [t, r, n, 1]) : (console.warn("unknown num color: " + e), [0, 0, 0, 1]);
        }, be = function be() {
          var e, n, r, t;return t = xe(arguments), r = t[0], n = t[1], e = t[2], (r << 16) + (n << 8) + e;
        }, y.num = function (n) {
          return new e(n, "num");
        }, e.prototype.num = function (e) {
          return null == e && (e = "rgb"), be(this._rgb, e);
        }, i.num = W, o.push({ p: 1, test: function test(e) {
            if (1 === arguments.length && "number" === Me(e) && e >= 0 && e <= 16777215) return "num";
          } }), j = function j() {
          var e, n, r, t, f, a, u, c, o, l, i, s, b, d, h, p, g, m, v, y;if (r = xe(arguments), c = r[0], f = r[1], n = r[2], f /= 100, u = u / 100 * 255, e = 255 * f, 0 === f) s = u = t = n;else switch (360 === c && (c = 0), c > 360 && (c -= 360), c < 0 && (c += 360), c /= 60, o = O(c), a = c - o, l = n * (1 - f), i = l + e * (1 - a), v = l + e * a, y = l + e, o) {case 0:
              b = [y, v, l], s = b[0], u = b[1], t = b[2];break;case 1:
              d = [i, y, l], s = d[0], u = d[1], t = d[2];break;case 2:
              h = [l, y, v], s = h[0], u = h[1], t = h[2];break;case 3:
              p = [l, i, y], s = p[0], u = p[1], t = p[2];break;case 4:
              g = [v, l, y], s = g[0], u = g[1], t = g[2];break;case 5:
              m = [y, l, i], s = m[0], u = m[1], t = m[2];}return [s, u, t, r.length > 3 ? r[3] : 1];
        }, fe = function fe() {
          var e, n, r, t, f, a, u, c, o;return o = xe(arguments), c = o[0], f = o[1], n = o[2], u = Math.min(c, f, n), J = Math.max(c, f, n), t = J - u, r = 100 * t / 255, e = u / (255 - t) * 100, 0 === t ? a = Number.NaN : (c === J && (a = (f - n) / t), f === J && (a = 2 + (n - c) / t), n === J && (a = 4 + (c - f) / t), (a *= 60) < 0 && (a += 360)), [a, r, e];
        }, y.hcg = function () {
          return function (e, n, r) {
            r.prototype = e.prototype;var t = new r(),
                f = e.apply(t, n);return Object(f) === f ? f : t;
          }(e, qe.call(arguments).concat(["hcg"]), function () {});
        }, i.hcg = j, e.prototype.hcg = function () {
          return fe(this._rgb);
        }, N = function N(e) {
          var n, r, t, f, a, u, c, o;if (e = e.toLowerCase(), null != y.colors && y.colors[e]) return q(y.colors[e]);if (a = e.match(/rgb\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*\)/)) {
            for (c = a.slice(1, 4), f = u = 0; u <= 2; f = ++u) {
              c[f] = +c[f];
            }c[3] = 1;
          } else if (a = e.match(/rgba\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*,\s*([01]|[01]?\.\d+)\)/)) for (c = a.slice(1, 5), f = o = 0; o <= 3; f = ++o) {
            c[f] = +c[f];
          } else if (a = e.match(/rgb\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
            for (c = a.slice(1, 4), f = n = 0; n <= 2; f = ++n) {
              c[f] = ye(2.55 * c[f]);
            }c[3] = 1;
          } else if (a = e.match(/rgba\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
            for (c = a.slice(1, 5), f = r = 0; r <= 2; f = ++r) {
              c[f] = ye(2.55 * c[f]);
            }c[3] = +c[3];
          } else (a = e.match(/hsl\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) ? (t = a.slice(1, 4), t[1] *= .01, t[2] *= .01, c = P(t), c[3] = 1) : (a = e.match(/hsla\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) && (t = a.slice(1, 4), t[1] *= .01, t[2] *= .01, c = P(t), c[3] = +a[4]);return c;
        }, te = function te(e) {
          var n;return n = e[3] < 1 ? "rgba" : "rgb", "rgb" === n ? n + "(" + e.slice(0, 3).map(ye).join(",") + ")" : "rgba" === n ? n + "(" + e.slice(0, 3).map(ye).join(",") + "," + e[3] + ")" : void 0;
        }, ge = function ge(e) {
          return ye(100 * e) / 100;
        }, L = function L(e, n) {
          var r;return r = n < 1 ? "hsla" : "hsl", e[0] = ge(e[0] || 0), e[1] = ge(100 * e[1]) + "%", e[2] = ge(100 * e[2]) + "%", "hsla" === r && (e[3] = n), r + "(" + e.join(",") + ")";
        }, i.css = function (e) {
          return N(e);
        }, y.css = function () {
          return function (e, n, r) {
            r.prototype = e.prototype;var t = new r(),
                f = e.apply(t, n);return Object(f) === f ? f : t;
          }(e, qe.call(arguments).concat(["css"]), function () {});
        }, e.prototype.css = function (e) {
          return null == e && (e = "rgb"), "rgb" === e.slice(0, 3) ? te(this._rgb) : "hsl" === e.slice(0, 3) ? L(this.hsl(), this.alpha()) : void 0;
        }, i.named = function (e) {
          return q(Ae[e]);
        }, o.push({ p: 5, test: function test(e) {
            if (1 === arguments.length && null != Ae[e]) return "named";
          } }), e.prototype.name = function (e) {
          var n, r;arguments.length && (Ae[e] && (this._rgb = q(Ae[e])), this._rgb[3] = 1), n = this.hex();for (r in Ae) {
            if (n === Ae[r]) return r;
          }return n;
        }, F = function F() {
          var e, r, t, f;return f = xe(arguments), t = f[0], e = f[1], r = f[2], r *= n, [t, _(r) * e, ke(r) * e];
        }, I = function I() {
          var e, n, r, t, f, a, u, c, o, l, i;return r = xe(arguments), c = r[0], f = r[1], u = r[2], l = F(c, f, u), e = l[0], n = l[1], t = l[2], i = V(e, n, t), o = i[0], a = i[1], t = i[2], [o, a, t, r.length > 3 ? r[3] : 1];
        }, U = function U() {
          var e, n, r, t, f, u;return u = xe(arguments), f = u[0], e = u[1], n = u[2], r = _e(e * e + n * n), t = (d(n, e) * a + 360) % 360, 0 === ye(1e4 * r) && (t = Number.NaN), [f, r, t];
        }, ie = function ie() {
          var e, n, r, t, f, a, u;return a = xe(arguments), f = a[0], r = a[1], n = a[2], u = le(f, r, n), t = u[0], e = u[1], n = u[2], U(t, e, n);
        }, y.lch = function () {
          var n;return n = xe(arguments), new e(n, "lch");
        }, y.hcl = function () {
          var n;return n = xe(arguments), new e(n, "hcl");
        }, i.lch = I, i.hcl = function () {
          var e, n, r, t;return t = xe(arguments), n = t[0], e = t[1], r = t[2], I([r, e, n]);
        }, e.prototype.lch = function () {
          return ie(this._rgb);
        }, e.prototype.hcl = function () {
          return ie(this._rgb).reverse();
        }, re = function re(e) {
          var n, r, t, f, a, u, c, o, l;return null == e && (e = "rgb"), o = xe(arguments), c = o[0], f = o[1], n = o[2], c /= 255, f /= 255, n /= 255, a = 1 - Math.max(c, Math.max(f, n)), t = a < 1 ? 1 / (1 - a) : 0, r = (1 - c - a) * t, u = (1 - f - a) * t, l = (1 - n - a) * t, [r, u, l, a];
        }, k = function k() {
          var e, n, r, t, f, a, u, c, o;return n = xe(arguments), t = n[0], u = n[1], o = n[2], a = n[3], e = n.length > 4 ? n[4] : 1, 1 === a ? [0, 0, 0, e] : (c = t >= 1 ? 0 : 255 * (1 - t) * (1 - a), f = u >= 1 ? 0 : 255 * (1 - u) * (1 - a), r = o >= 1 ? 0 : 255 * (1 - o) * (1 - a), [c, f, r, e]);
        }, i.cmyk = function () {
          return k(xe(arguments));
        }, y.cmyk = function () {
          return function (e, n, r) {
            r.prototype = e.prototype;var t = new r(),
                f = e.apply(t, n);return Object(f) === f ? f : t;
          }(e, qe.call(arguments).concat(["cmyk"]), function () {});
        }, e.prototype.cmyk = function () {
          return re(this._rgb);
        }, i.gl = function () {
          var e, n, r, t, f;for (t = function () {
            var e, r;e = xe(arguments), r = [];for (n in e) {
              f = e[n], r.push(f);
            }return r;
          }.apply(this, arguments), e = r = 0; r <= 2; e = ++r) {
            t[e] *= 255;
          }return t;
        }, y.gl = function () {
          return function (e, n, r) {
            r.prototype = e.prototype;var t = new r(),
                f = e.apply(t, n);return Object(f) === f ? f : t;
          }(e, qe.call(arguments).concat(["gl"]), function () {});
        }, e.prototype.gl = function () {
          var e;return e = this._rgb, [e[0] / 255, e[1] / 255, e[2] / 255, e[3]];
        }, se = function se(e, n, r) {
          var t;return t = xe(arguments), e = t[0], n = t[1], r = t[2], e = $(e), n = $(n), r = $(r), .2126 * e + .7152 * n + .0722 * r;
        }, $ = function $(e) {
          return e /= 255, e <= .03928 ? e / 12.92 : ne((e + .055) / 1.055, 2.4);
        }, z = function z(n, r, t, f) {
          var a, u;return a = n._rgb, u = r._rgb, new e(a[0] + t * (u[0] - a[0]), a[1] + t * (u[1] - a[1]), a[2] + t * (u[2] - a[2]), f);
        }, s.push(["rgb", z]), e.prototype.luminance = function (e, n) {
          var r, t, f, _a;return null == n && (n = "rgb"), arguments.length ? (0 === e ? this._rgb = [0, 0, 0, this._rgb[3]] : 1 === e ? this._rgb = [255, 255, 255, this._rgb[3]] : (t = 1e-7, f = 20, _a = function a(r, u) {
            var c, o;return o = r.interpolate(u, .5, n), c = o.luminance(), Math.abs(e - c) < t || !f-- ? o : c > e ? _a(r, o) : _a(o, u);
          }, r = se(this._rgb), this._rgb = (r > e ? _a(y("black"), this) : _a(this, y("white"))).rgba()), this) : se(this._rgb);
        }, Ne = function Ne(e) {
          var n, r, t, f;return f = e / 100, f < 66 ? (t = 255, r = -155.25485562709179 - .44596950469579133 * (r = f - 2) + 104.49216199393888 * D(r), n = f < 20 ? 0 : .8274096064007395 * (n = f - 10) - 254.76935184120902 + 115.67994401066147 * D(n)) : (t = 351.97690566805693 + .114206453784165 * (t = f - 55) - 40.25366309332127 * D(t), r = 325.4494125711974 + .07943456536662342 * (r = f - 50) - 28.0852963507957 * D(r), n = 255), [t, r, n];
        }, de = function de() {
          var e, n, r, t, f, a, u, c;for (a = xe(arguments), f = a[0], a[1], e = a[2], t = 1e3, r = 4e4, n = .4; r - t > n;) {
            c = .5 * (r + t), u = Ne(c), u[2] / u[0] >= e / f ? r = c : t = c;
          }return ye(c);
        }, y.temperature = y.kelvin = function () {
          return function (e, n, r) {
            r.prototype = e.prototype;var t = new r(),
                f = e.apply(t, n);return Object(f) === f ? f : t;
          }(e, qe.call(arguments).concat(["temperature"]), function () {});
        }, i.temperature = i.kelvin = i.K = Ne, e.prototype.temperature = function () {
          return de(this._rgb);
        }, e.prototype.kelvin = e.prototype.temperature, y.contrast = function (n, r) {
          var t, f, a, u;return "string" !== (a = Me(n)) && "number" !== a || (n = new e(n)), "string" !== (u = Me(r)) && "number" !== u || (r = new e(r)), t = n.luminance(), f = r.luminance(), t > f ? (t + .05) / (f + .05) : (f + .05) / (t + .05);
        }, y.distance = function (n, r, t) {
          var f, a, u, c, o, l, i;null == t && (t = "lab"), "string" !== (o = Me(n)) && "number" !== o || (n = new e(n)), "string" !== (l = Me(r)) && "number" !== l || (r = new e(r)), u = n.get(t), c = r.get(t), i = 0;for (a in u) {
            f = (u[a] || 0) - (c[a] || 0), i += f * f;
          }return Math.sqrt(i);
        }, y.deltaE = function (n, r, f, a) {
          var u, c, o, l, i, s, h, p, g, m, v, y, w, k, N, M, x, A, O, j, q, G, L, P, B, R, Y;for (null == f && (f = 1), null == a && (a = 1), "string" !== (x = Me(n)) && "number" !== x || (n = new e(n)), "string" !== (A = Me(r)) && "number" !== A || (r = new e(r)), O = n.lab(), u = O[0], o = O[1], i = O[2], j = r.lab(), c = j[0], l = j[1], s = j[2], h = _e(o * o + i * i), p = _e(l * l + s * s), L = u < 16 ? .511 : .040975 * u / (1 + .01765 * u), q = .0638 * h / (1 + .0131 * h) + .638, M = h < 1e-6 ? 0 : 180 * d(i, o) / t; M < 0;) {
            M += 360;
          }for (; M >= 360;) {
            M -= 360;
          }return P = M >= 164 && M <= 345 ? .56 + b(.2 * _(t * (M + 168) / 180)) : .36 + b(.4 * _(t * (M + 35) / 180)), g = h * h * h * h, N = _e(g / (g + 1900)), G = q * (N * P + 1 - N), k = u - c, w = h - p, v = o - l, y = i - s, m = v * v + y * y - w * w, B = k / (f * L), R = w / (a * q), Y = G, _e(B * B + R * R + m / (Y * Y));
        }, e.prototype.get = function (e) {
          var n, r, t, f, a, u;return t = this, a = e.split("."), f = a[0], n = a[1], u = t[f](), n ? (r = f.indexOf(n), r > -1 ? u[r] : console.warn("unknown channel " + n + " in mode " + f)) : u;
        }, e.prototype.set = function (e, n) {
          var r, t, f, a, u, c;if (f = this, u = e.split("."), a = u[0], r = u[1], r) {
            if (c = f[a](), (t = a.indexOf(r)) > -1) {
              if ("string" === Me(n)) switch (n.charAt(0)) {case "+":case "-":
                  c[t] += +n;break;case "*":
                  c[t] *= +n.substr(1);break;case "/":
                  c[t] /= +n.substr(1);break;default:
                  c[t] = +n;} else c[t] = n;
            } else console.warn("unknown channel " + r + " in mode " + a);
          } else c = n;return y(c, a).alpha(f.alpha());
        }, e.prototype.clipped = function () {
          return this._rgb._clipped || !1;
        }, e.prototype.alpha = function (e) {
          return arguments.length ? y.rgb([this._rgb[0], this._rgb[1], this._rgb[2], e]) : this._rgb[3];
        }, e.prototype.darken = function (e) {
          var n, t;return null == e && (e = 1), t = this, n = t.lab(), n[0] -= r.Kn * e, y.lab(n).alpha(t.alpha());
        }, e.prototype.brighten = function (e) {
          return null == e && (e = 1), this.darken(-e);
        }, e.prototype.darker = e.prototype.darken, e.prototype.brighter = e.prototype.brighten, e.prototype.saturate = function (e) {
          var n, t;return null == e && (e = 1), t = this, n = t.lch(), n[1] += e * r.Kn, n[1] < 0 && (n[1] = 0), y.lch(n).alpha(t.alpha());
        }, e.prototype.desaturate = function (e) {
          return null == e && (e = 1), this.saturate(-e);
        }, e.prototype.premultiply = function () {
          var e, n;return n = this.rgb(), e = this.alpha(), y(n[0] * e, n[1] * e, n[2] * e, e);
        }, _p = function p(e, n, r) {
          if (!_p[r]) throw "unknown blend mode " + r;return _p[r](e, n);
        }, g = function g(e) {
          return function (n, r) {
            var t, f;return t = y(r).rgb(), f = y(n).rgb(), y(e(t, f), "rgb");
          };
        }, A = function A(e) {
          return function (n, r) {
            var t, f, a;for (a = [], t = f = 0; f <= 3; t = ++f) {
              a[t] = e(n[t], r[t]);
            }return a;
          };
        }, T = function T(e, n) {
          return e;
        }, Q = function Q(e, n) {
          return e * n / 255;
        }, M = function M(e, n) {
          return e > n ? n : e;
        }, K = function K(e, n) {
          return e > n ? e : n;
        }, we = function we(e, n) {
          return 255 * (1 - (1 - e / 255) * (1 - n / 255));
        }, ee = function ee(e, n) {
          return n < 128 ? 2 * e * n / 255 : 255 * (1 - 2 * (1 - e / 255) * (1 - n / 255));
        }, v = function v(e, n) {
          return 255 * (1 - (1 - n / 255) / (e / 255));
        }, x = function x(e, n) {
          return 255 === e ? 255 : (e = n / 255 * 255 / (1 - e / 255), e > 255 ? 255 : e);
        }, _p.normal = g(A(T)), _p.multiply = g(A(Q)), _p.screen = g(A(we)), _p.overlay = g(A(ee)), _p.darken = g(A(M)), _p.lighten = g(A(K)), _p.dodge = g(A(x)), _p.burn = g(A(v)), y.blend = _p, y.analyze = function (e) {
          var n, r, t, f;for (t = { min: Number.MAX_VALUE, max: -1 * Number.MAX_VALUE, sum: 0, values: [], count: 0 }, r = 0, n = e.length; r < n; r++) {
            null == (f = e[r]) || isNaN(f) || (t.values.push(f), t.sum += f, f < t.min && (t.min = f), f > t.max && (t.max = f), t.count += 1);
          }return t.domain = [t.min, t.max], t.limits = function (e, n) {
            return y.limits(t, e, n);
          }, t;
        }, y.scale = function (e, n) {
          var r, t, f, a, u, c, o, l, i, s, b, d, h, p, g, m, v, w, k, _, N;return i = "rgb", s = y("#ccc"), p = 0, !1, u = [0, 1], h = [], d = [0, 0], r = !1, f = [], b = !1, l = 0, o = 1, a = !1, t = {}, g = !0, c = 1, _ = function _(e) {
            var n, r, t, a, u, c;if (null == e && (e = ["#fff", "#000"]), null != e && "string" === Me(e) && null != y.brewer && (e = y.brewer[e] || y.brewer[e.toLowerCase()] || e), "array" === Me(e)) {
              for (e = e.slice(0), n = t = 0, a = e.length - 1; 0 <= a ? t <= a : t >= a; n = 0 <= a ? ++t : --t) {
                r = e[n], "string" === Me(r) && (e[n] = y(r));
              }for (h.length = 0, n = c = 0, u = e.length - 1; 0 <= u ? c <= u : c >= u; n = 0 <= u ? ++c : --c) {
                h.push(n / (e.length - 1));
              }
            }return k(), f = e;
          }, v = function v(e) {
            var n, t;if (null != r) {
              for (t = r.length - 1, n = 0; n < t && e >= r[n];) {
                n++;
              }return n - 1;
            }return 0;
          }, N = function N(e) {
            return e;
          }, function (e) {
            var n, t, f, a, u;return u = e, r.length > 2 && (a = r.length - 1, n = v(e), f = r[0] + (r[1] - r[0]) * (0 + .5 * p), t = r[a - 1] + (r[a] - r[a - 1]) * (1 - .5 * p), u = l + (r[n] + .5 * (r[n + 1] - r[n]) - f) / (t - f) * (o - l)), u;
          }, w = function w(e, n) {
            var a, u, b, p, m, w, k, _;if (null == n && (n = !1), isNaN(e)) return s;if (n ? _ = e : r && r.length > 2 ? (a = v(e), _ = a / (r.length - 2)) : _ = o !== l ? (e - l) / (o - l) : 1, n || (_ = N(_)), 1 !== c && (_ = ne(_, c)), _ = d[0] + _ * (1 - d[0] - d[1]), _ = Math.min(1, Math.max(0, _)), p = Math.floor(1e4 * _), g && t[p]) u = t[p];else {
              if ("array" === Me(f)) for (b = m = 0, k = h.length - 1; 0 <= k ? m <= k : m >= k; b = 0 <= k ? ++m : --m) {
                if (w = h[b], _ <= w) {
                  u = f[b];break;
                }if (_ >= w && b === h.length - 1) {
                  u = f[b];break;
                }if (_ > w && _ < h[b + 1]) {
                  _ = (_ - w) / (h[b + 1] - w), u = y.interpolate(f[b], f[b + 1], _, i);break;
                }
              } else "function" === Me(f) && (u = f(_));g && (t[p] = u);
            }return u;
          }, k = function k() {
            return t = {};
          }, _(e), m = function m(e) {
            var n;return n = y(w(e)), b && n[b] ? n[b]() : n;
          }, m.classes = function (e) {
            var n;return null != e ? ("array" === Me(e) ? (r = e, u = [e[0], e[e.length - 1]]) : (n = y.analyze(u), r = 0 === e ? [n.min, n.max] : y.limits(n, "e", e)), m) : r;
          }, m.domain = function (e) {
            var n, r, t, a, c, i, s;if (!arguments.length) return u;if (l = e[0], o = e[e.length - 1], h = [], t = f.length, e.length === t && l !== o) for (c = 0, a = e.length; c < a; c++) {
              r = e[c], h.push((r - l) / (o - l));
            } else for (n = s = 0, i = t - 1; 0 <= i ? s <= i : s >= i; n = 0 <= i ? ++s : --s) {
              h.push(n / (t - 1));
            }return u = [l, o], m;
          }, m.mode = function (e) {
            return arguments.length ? (i = e, k(), m) : i;
          }, m.range = function (e, n) {
            return _(e, n), m;
          }, m.out = function (e) {
            return b = e, m;
          }, m.spread = function (e) {
            return arguments.length ? (p = e, m) : p;
          }, m.correctLightness = function (e) {
            return null == e && (e = !0), a = e, k(), N = a ? function (e) {
              var n, r, t, f, a, u, c, o, l;for (n = w(0, !0).lab()[0], r = w(1, !0).lab()[0], c = n > r, t = w(e, !0).lab()[0], a = n + (r - n) * e, f = t - a, o = 0, l = 1, u = 20; Math.abs(f) > .01 && u-- > 0;) {
                !function () {
                  c && (f *= -1), f < 0 ? (o = e, e += .5 * (l - e)) : (l = e, e += .5 * (o - e)), t = w(e, !0).lab()[0], f = t - a;
                }();
              }return e;
            } : function (e) {
              return e;
            }, m;
          }, m.padding = function (e) {
            return null != e ? ("number" === Me(e) && (e = [e, e]), d = e, m) : d;
          }, m.colors = function (n, t) {
            var a, c, o, l, i, s, b, d;if (arguments.length < 2 && (t = "hex"), i = [], 0 === arguments.length) i = f.slice(0);else if (1 === n) i = [m(.5)];else if (n > 1) c = u[0], a = u[1] - c, i = function () {
              s = [];for (var e = 0; 0 <= n ? e < n : e > n; 0 <= n ? e++ : e--) {
                s.push(e);
              }return s;
            }.apply(this).map(function (e) {
              return m(c + e / (n - 1) * a);
            });else {
              if (e = [], b = [], r && r.length > 2) for (o = d = 1, l = r.length; 1 <= l ? d < l : d > l; o = 1 <= l ? ++d : --d) {
                b.push(.5 * (r[o - 1] + r[o]));
              } else b = u;i = b.map(function (e) {
                return m(e);
              });
            }return y[t] && (i = i.map(function (e) {
              return e[t]();
            })), i;
          }, m.cache = function (e) {
            return null != e ? (g = e, m) : g;
          }, m.gamma = function (e) {
            return null != e ? (c = e, m) : c;
          }, m;
        }, null == y.scales && (y.scales = {}), y.scales.cool = function () {
          return y.scale([y.hsl(180, 1, .9), y.hsl(250, .7, .4)]);
        }, y.scales.hot = function () {
          return y.scale(["#000", "#f00", "#ff0", "#fff"], [0, .25, .75, 1]).mode("rgb");
        }, y.analyze = function (e, n, r) {
          var t, f, a, u, c, o, l;if (c = { min: Number.MAX_VALUE, max: -1 * Number.MAX_VALUE, sum: 0, values: [], count: 0 }, null == r && (r = function r() {
            return !0;
          }), t = function t(e) {
            null == e || isNaN(e) || (c.values.push(e), c.sum += e, e < c.min && (c.min = e), e > c.max && (c.max = e), c.count += 1);
          }, l = function l(e, f) {
            if (r(e, f)) return t(null != n && "function" === Me(n) ? n(e) : null != n && "string" === Me(n) || "number" === Me(n) ? e[n] : e);
          }, "array" === Me(e)) for (u = 0, a = e.length; u < a; u++) {
            o = e[u], l(o);
          } else for (f in e) {
            o = e[f], l(o, f);
          }return c.domain = [c.min, c.max], c.limits = function (e, n) {
            return y.limits(c, e, n);
          }, c;
        }, y.limits = function (e, n, r) {
          var t, f, a, u, c, o, l, i, s, d, h, p, g, m, v, w, k, _, N, M, x, A, j, q, G, L, P, B, R, Y, E, S, X, z, U, V, C, F, I, K, Z, $, H, Q, T, W, ee, re, te, fe, ae, ue, ce, oe, le;if (null == n && (n = "equal"), null == r && (r = 7), "array" === Me(e) && (e = y.analyze(e)), G = e.min, J = e.max, e.sum, oe = e.values.sort(function (e, n) {
            return e - n;
          }), 1 === r) return [G, J];if (j = [], "c" === n.substr(0, 1) && (j.push(G), j.push(J)), "e" === n.substr(0, 1)) {
            for (j.push(G), M = E = 1, U = r - 1; 1 <= U ? E <= U : E >= U; M = 1 <= U ? ++E : --E) {
              j.push(G + M / r * (J - G));
            }j.push(J);
          } else if ("l" === n.substr(0, 1)) {
            if (G <= 0) throw "Logarithmic scales are only possible for values > 0";for (L = Math.LOG10E * D(G), q = Math.LOG10E * D(J), j.push(G), M = le = 1, V = r - 1; 1 <= V ? le <= V : le >= V; M = 1 <= V ? ++le : --le) {
              j.push(ne(10, L + M / r * (q - L)));
            }j.push(J);
          } else if ("q" === n.substr(0, 1)) {
            for (j.push(G), M = t = 1, $ = r - 1; 1 <= $ ? t <= $ : t >= $; M = 1 <= $ ? ++t : --t) {
              S = (oe.length - 1) * M / r, X = O(S), X === S ? j.push(oe[X]) : (z = S - X, j.push(oe[X] * (1 - z) + oe[X + 1] * z));
            }j.push(J);
          } else if ("k" === n.substr(0, 1)) {
            for (B = oe.length, m = new Array(B), _ = new Array(r), fe = !0, R = 0, w = null, w = [], w.push(G), M = f = 1, H = r - 1; 1 <= H ? f <= H : f >= H; M = 1 <= H ? ++f : --f) {
              w.push(G + M / r * (J - G));
            }for (w.push(J); fe;) {
              for (x = a = 0, Q = r - 1; 0 <= Q ? a <= Q : a >= Q; x = 0 <= Q ? ++a : --a) {
                _[x] = 0;
              }for (M = u = 0, T = B - 1; 0 <= T ? u <= T : u >= T; M = 0 <= T ? ++u : --u) {
                for (ce = oe[M], P = Number.MAX_VALUE, x = c = 0, W = r - 1; 0 <= W ? c <= W : c >= W; x = 0 <= W ? ++c : --c) {
                  (N = b(w[x] - ce)) < P && (P = N, v = x);
                }_[v]++, m[M] = v;
              }for (Y = new Array(r), x = o = 0, ee = r - 1; 0 <= ee ? o <= ee : o >= ee; x = 0 <= ee ? ++o : --o) {
                Y[x] = null;
              }for (M = l = 0, re = B - 1; 0 <= re ? l <= re : l >= re; M = 0 <= re ? ++l : --l) {
                k = m[M], null === Y[k] ? Y[k] = oe[M] : Y[k] += oe[M];
              }for (x = i = 0, te = r - 1; 0 <= te ? i <= te : i >= te; x = 0 <= te ? ++i : --i) {
                Y[x] *= 1 / _[x];
              }for (fe = !1, x = s = 0, C = r - 1; 0 <= C ? s <= C : s >= C; x = 0 <= C ? ++s : --s) {
                if (Y[x] !== w[M]) {
                  fe = !0;break;
                }
              }w = Y, R++, R > 200 && (fe = !1);
            }for (A = {}, x = d = 0, F = r - 1; 0 <= F ? d <= F : d >= F; x = 0 <= F ? ++d : --d) {
              A[x] = [];
            }for (M = h = 0, I = B - 1; 0 <= I ? h <= I : h >= I; M = 0 <= I ? ++h : --h) {
              k = m[M], A[k].push(oe[M]);
            }for (ae = [], x = p = 0, K = r - 1; 0 <= K ? p <= K : p >= K; x = 0 <= K ? ++p : --p) {
              ae.push(A[x][0]), ae.push(A[x][A[x].length - 1]);
            }for (ae = ae.sort(function (e, n) {
              return e - n;
            }), j.push(ae[0]), M = g = 1, Z = ae.length - 1; g <= Z; M = g += 2) {
              ue = ae[M], isNaN(ue) || -1 !== j.indexOf(ue) || j.push(ue);
            }
          }return j;
        }, G = function G(e, n, r) {
          var t, a, c, o;return t = xe(arguments), e = t[0], n = t[1], r = t[2], isNaN(e) && (e = 0), e /= 360, e < 1 / 3 ? (a = (1 - n) / 3, o = (1 + n * _(u * e) / _(f - u * e)) / 3, c = 1 - (a + o)) : e < 2 / 3 ? (e -= 1 / 3, o = (1 - n) / 3, c = (1 + n * _(u * e) / _(f - u * e)) / 3, a = 1 - (o + c)) : (e -= 2 / 3, c = (1 - n) / 3, a = (1 + n * _(u * e) / _(f - u * e)) / 3, o = 1 - (c + a)), o = Z(r * o * 3), c = Z(r * c * 3), a = Z(r * a * 3), [255 * o, 255 * c, 255 * a, t.length > 3 ? t[3] : 1];
        }, ue = function ue() {
          var e, n, r, t, f, a, c, o;return c = xe(arguments), a = c[0], n = c[1], e = c[2], u = 2 * Math.PI, a /= 255, n /= 255, e /= 255, f = Math.min(a, n, e), t = (a + n + e) / 3, o = 1 - f / t, 0 === o ? r = 0 : (r = (a - n + (a - e)) / 2, r /= Math.sqrt((a - n) * (a - n) + (a - e) * (n - e)), r = Math.acos(r), e > n && (r = u - r), r /= u), [360 * r, o, t];
        }, y.hsi = function () {
          return function (e, n, r) {
            r.prototype = e.prototype;var t = new r(),
                f = e.apply(t, n);return Object(f) === f ? f : t;
          }(e, qe.call(arguments).concat(["hsi"]), function () {});
        }, i.hsi = G, e.prototype.hsi = function () {
          return ue(this._rgb);
        }, Y = function Y(e, n, r, t) {
          var f, a, u, c, o, l, i, s, b, d, h, p;return "hsl" === t ? (h = e.hsl(), p = n.hsl()) : "hsv" === t ? (h = e.hsv(), p = n.hsv()) : "hcg" === t ? (h = e.hcg(), p = n.hcg()) : "hsi" === t ? (h = e.hsi(), p = n.hsi()) : "lch" !== t && "hcl" !== t || (t = "hcl", h = e.hcl(), p = n.hcl()), "h" === t.substr(0, 1) && (u = h[0], b = h[1], l = h[2], c = p[0], d = p[1], i = p[2]), isNaN(u) || isNaN(c) ? isNaN(u) ? isNaN(c) ? a = Number.NaN : (a = c, 1 !== l && 0 !== l || "hsv" === t || (s = d)) : (a = u, 1 !== i && 0 !== i || "hsv" === t || (s = b)) : (f = c > u && c - u > 180 ? c - (u + 360) : c < u && u - c > 180 ? c + 360 - u : c - u, a = u + r * f), null == s && (s = b + r * (d - b)), o = l + r * (i - l), y[t](a, s, o);
        }, s = s.concat(function () {
          var e, n, r, t;for (r = ["hsv", "hsl", "hsi", "hcl", "lch", "hcg"], t = [], n = 0, e = r.length; n < e; n++) {
            H = r[n], t.push([H, Y]);
          }return t;
        }()), X = function X(e, n, r, t) {
          var f, a;return f = e.num(), a = n.num(), y.num(f + (a - f) * r, "num");
        }, s.push(["num", X]), E = function E(n, r, t, f) {
          var a, u;return a = n.lab(), u = r.lab(), new e(a[0] + t * (u[0] - a[0]), a[1] + t * (u[1] - a[1]), a[2] + t * (u[2] - a[2]), f);
        }, s.push(["lab", E]);
      }).call(this);
    }, {}], 9: [function (_dereq_, module, exports) {
      module.exports = function e(t) {
        switch (t && t.type || null) {case "FeatureCollection":
            return t.features = t.features.reduce(function (t, r) {
              return t.concat(e(r));
            }, []), t;case "Feature":
            return t.geometry ? e(t.geometry).map(function (e) {
              var r = { type: "Feature", properties: JSON.parse(JSON.stringify(t.properties)), geometry: e };return void 0 !== t.id && (r.id = t.id), r;
            }) : [t];case "MultiPoint":
            return t.coordinates.map(function (e) {
              return { type: "Point", coordinates: e };
            });case "MultiPolygon":
            return t.coordinates.map(function (e) {
              return { type: "Polygon", coordinates: e };
            });case "MultiLineString":
            return t.coordinates.map(function (e) {
              return { type: "LineString", coordinates: e };
            });case "GeometryCollection":
            return t.geometries.map(e).reduce(function (e, t) {
              return e.concat(t);
            }, []);case "Point":case "Polygon":case "LineString":
            return [t];}
      };
    }, {}], 10: [function (_dereq_, module, exports) {
      "use strict";
      var Response = function () {
        function t(t, s, e, o) {
          if ("number" != typeof t) throw new TypeError("statusCode must be a number but was " + (typeof t === "undefined" ? "undefined" : _typeof(t)));if (null === s) throw new TypeError("headers cannot be null");if ("object" != (typeof s === "undefined" ? "undefined" : _typeof(s))) throw new TypeError("headers must be an object but was " + (typeof s === "undefined" ? "undefined" : _typeof(s)));this.statusCode = t;var r = {};for (var i in s) {
            r[i.toLowerCase()] = s[i];
          }this.headers = r, this.body = e, this.url = o;
        }return t.prototype.isError = function () {
          return 0 === this.statusCode || this.statusCode >= 400;
        }, t.prototype.getBody = function (t) {
          if (0 === this.statusCode) {
            var s = new Error("This request to " + this.url + " resulted in a status code of 0. This usually indicates some kind of network error in a browser (e.g. CORS not being set up or the DNS failing to resolve):\n" + this.body.toString());throw s.statusCode = this.statusCode, s.headers = this.headers, s.body = this.body, s.url = this.url, s;
          }if (this.statusCode >= 300) {
            var s = new Error("Server responded to " + this.url + " with status code " + this.statusCode + ":\n" + this.body.toString());throw s.statusCode = this.statusCode, s.headers = this.headers, s.body = this.body, s.url = this.url, s;
          }return t && "string" != typeof this.body ? this.body.toString(t) : this.body;
        }, t;
      }();module.exports = Response;
    }, {}], 11: [function (_dereq_, module, exports) {
      "use strict";
      var replace = String.prototype.replace,
          percentTwenties = /%20/g;module.exports = { default: "RFC3986", formatters: { RFC1738: function RFC1738(e) {
            return replace.call(e, percentTwenties, "+");
          }, RFC3986: function RFC3986(e) {
            return String(e);
          } }, RFC1738: "RFC1738", RFC3986: "RFC3986" };
    }, {}], 12: [function (_dereq_, module, exports) {
      "use strict";
      var stringify = _dereq_("./stringify"),
          parse = _dereq_("./parse"),
          formats = _dereq_("./formats");module.exports = { formats: formats, parse: parse, stringify: stringify };
    }, { "./formats": 11, "./parse": 13, "./stringify": 14 }], 13: [function (_dereq_, module, exports) {
      "use strict";
      var utils = _dereq_("./utils"),
          has = Object.prototype.hasOwnProperty,
          defaults = { allowDots: !1, allowPrototypes: !1, arrayLimit: 20, decoder: utils.decode, delimiter: "&", depth: 5, parameterLimit: 1e3, plainObjects: !1, strictNullHandling: !1 },
          parseValues = function parseValues(e, t) {
        for (var r = {}, a = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e, l = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit, i = a.split(t.delimiter, l), o = 0; o < i.length; ++o) {
          var s,
              n,
              c = i[o],
              d = c.indexOf("]="),
              p = -1 === d ? c.indexOf("=") : d + 1;-1 === p ? (s = t.decoder(c, defaults.decoder), n = t.strictNullHandling ? null : "") : (s = t.decoder(c.slice(0, p), defaults.decoder), n = t.decoder(c.slice(p + 1), defaults.decoder)), has.call(r, s) ? r[s] = [].concat(r[s]).concat(n) : r[s] = n;
        }return r;
      },
          parseObject = function parseObject(e, t, r) {
        for (var a = t, l = e.length - 1; l >= 0; --l) {
          var i,
              o = e[l];if ("[]" === o && r.parseArrays) i = [].concat(a);else {
            i = r.plainObjects ? Object.create(null) : {};var s = "[" === o.charAt(0) && "]" === o.charAt(o.length - 1) ? o.slice(1, -1) : o,
                n = parseInt(s, 10);r.parseArrays || "" !== s ? !isNaN(n) && o !== s && String(n) === s && n >= 0 && r.parseArrays && n <= r.arrayLimit ? (i = [], i[n] = a) : "__proto__" !== s && (i[s] = a) : i = { 0: a };
          }a = i;
        }return a;
      },
          parseKeys = function parseKeys(e, t, r) {
        if (e) {
          var a = r.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e,
              l = /(\[[^[\]]*])/,
              i = /(\[[^[\]]*])/g,
              o = l.exec(a),
              s = o ? a.slice(0, o.index) : a,
              n = [];if (s) {
            if (!r.plainObjects && has.call(Object.prototype, s) && !r.allowPrototypes) return;n.push(s);
          }for (var c = 0; null !== (o = i.exec(a)) && c < r.depth;) {
            if (c += 1, !r.plainObjects && has.call(Object.prototype, o[1].slice(1, -1)) && !r.allowPrototypes) return;n.push(o[1]);
          }return o && n.push("[" + a.slice(o.index) + "]"), parseObject(n, t, r);
        }
      };module.exports = function (e, t) {
        var r = t ? utils.assign({}, t) : {};if (null !== r.decoder && void 0 !== r.decoder && "function" != typeof r.decoder) throw new TypeError("Decoder has to be a function.");if (r.ignoreQueryPrefix = !0 === r.ignoreQueryPrefix, r.delimiter = "string" == typeof r.delimiter || utils.isRegExp(r.delimiter) ? r.delimiter : defaults.delimiter, r.depth = "number" == typeof r.depth ? r.depth : defaults.depth, r.arrayLimit = "number" == typeof r.arrayLimit ? r.arrayLimit : defaults.arrayLimit, r.parseArrays = !1 !== r.parseArrays, r.decoder = "function" == typeof r.decoder ? r.decoder : defaults.decoder, r.allowDots = "boolean" == typeof r.allowDots ? r.allowDots : defaults.allowDots, r.plainObjects = "boolean" == typeof r.plainObjects ? r.plainObjects : defaults.plainObjects, r.allowPrototypes = "boolean" == typeof r.allowPrototypes ? r.allowPrototypes : defaults.allowPrototypes, r.parameterLimit = "number" == typeof r.parameterLimit ? r.parameterLimit : defaults.parameterLimit, r.strictNullHandling = "boolean" == typeof r.strictNullHandling ? r.strictNullHandling : defaults.strictNullHandling, "" === e || null === e || void 0 === e) return r.plainObjects ? Object.create(null) : {};for (var a = "string" == typeof e ? parseValues(e, r) : e, l = r.plainObjects ? Object.create(null) : {}, i = Object.keys(a), o = 0; o < i.length; ++o) {
          var s = i[o],
              n = parseKeys(s, a[s], r);l = utils.merge(l, n, r);
        }return utils.compact(l);
      };
    }, { "./utils": 15 }], 14: [function (_dereq_, module, exports) {
      "use strict";
      var utils = _dereq_("./utils"),
          formats = _dereq_("./formats"),
          arrayPrefixGenerators = { brackets: function brackets(e) {
          return e + "[]";
        }, indices: function indices(e, r) {
          return e + "[" + r + "]";
        }, repeat: function repeat(e) {
          return e;
        } },
          isArray = Array.isArray,
          push = Array.prototype.push,
          pushToArray = function pushToArray(e, r) {
        push.apply(e, isArray(r) ? r : [r]);
      },
          toISO = Date.prototype.toISOString,
          defaults = { delimiter: "&", encode: !0, encoder: utils.encode, encodeValuesOnly: !1, serializeDate: function serializeDate(e) {
          return toISO.call(e);
        }, skipNulls: !1, strictNullHandling: !1 },
          stringify = function e(r, t, o, n, a, i, l, s, f, u, d, c) {
        var y = r;if ("function" == typeof l ? y = l(t, y) : y instanceof Date && (y = u(y)), null === y) {
          if (n) return i && !c ? i(t, defaults.encoder) : t;y = "";
        }if ("string" == typeof y || "number" == typeof y || "boolean" == typeof y || utils.isBuffer(y)) {
          if (i) {
            return [d(c ? t : i(t, defaults.encoder)) + "=" + d(i(y, defaults.encoder))];
          }return [d(t) + "=" + d(String(y))];
        }var p = [];if (void 0 === y) return p;var v;if (isArray(l)) v = l;else {
          var m = Object.keys(y);v = s ? m.sort(s) : m;
        }for (var h = 0; h < v.length; ++h) {
          var g = v[h];a && null === y[g] || (isArray(y) ? pushToArray(p, e(y[g], o(t, g), o, n, a, i, l, s, f, u, d, c)) : pushToArray(p, e(y[g], t + (f ? "." + g : "[" + g + "]"), o, n, a, i, l, s, f, u, d, c)));
        }return p;
      };module.exports = function (e, r) {
        var t = e,
            o = r ? utils.assign({}, r) : {};if (null !== o.encoder && void 0 !== o.encoder && "function" != typeof o.encoder) throw new TypeError("Encoder has to be a function.");var n = void 0 === o.delimiter ? defaults.delimiter : o.delimiter,
            a = "boolean" == typeof o.strictNullHandling ? o.strictNullHandling : defaults.strictNullHandling,
            i = "boolean" == typeof o.skipNulls ? o.skipNulls : defaults.skipNulls,
            l = "boolean" == typeof o.encode ? o.encode : defaults.encode,
            s = "function" == typeof o.encoder ? o.encoder : defaults.encoder,
            f = "function" == typeof o.sort ? o.sort : null,
            u = void 0 !== o.allowDots && o.allowDots,
            d = "function" == typeof o.serializeDate ? o.serializeDate : defaults.serializeDate,
            c = "boolean" == typeof o.encodeValuesOnly ? o.encodeValuesOnly : defaults.encodeValuesOnly;if (void 0 === o.format) o.format = formats.default;else if (!Object.prototype.hasOwnProperty.call(formats.formatters, o.format)) throw new TypeError("Unknown format option provided.");var y,
            p,
            v = formats.formatters[o.format];"function" == typeof o.filter ? (p = o.filter, t = p("", t)) : isArray(o.filter) && (p = o.filter, y = p);var m = [];if ("object" != (typeof t === "undefined" ? "undefined" : _typeof(t)) || null === t) return "";var h;h = o.arrayFormat in arrayPrefixGenerators ? o.arrayFormat : "indices" in o ? o.indices ? "indices" : "repeat" : "indices";var g = arrayPrefixGenerators[h];y || (y = Object.keys(t)), f && y.sort(f);for (var b = 0; b < y.length; ++b) {
          var A = y[b];i && null === t[A] || pushToArray(m, stringify(t[A], A, g, a, i, l ? s : null, p, f, u, d, v, c));
        }var O = m.join(n),
            k = !0 === o.addQueryPrefix ? "?" : "";return O.length > 0 ? k + O : "";
      };
    }, { "./formats": 11, "./utils": 15 }], 15: [function (_dereq_, module, exports) {
      "use strict";
      var has = Object.prototype.hasOwnProperty,
          hexTable = function () {
        for (var e = [], r = 0; r < 256; ++r) {
          e.push("%" + ((r < 16 ? "0" : "") + r.toString(16)).toUpperCase());
        }return e;
      }(),
          compactQueue = function compactQueue(e) {
        for (var r; e.length;) {
          var t = e.pop();if (r = t.obj[t.prop], Array.isArray(r)) {
            for (var o = [], a = 0; a < r.length; ++a) {
              void 0 !== r[a] && o.push(r[a]);
            }t.obj[t.prop] = o;
          }
        }return r;
      },
          arrayToObject = function arrayToObject(e, r) {
        for (var t = r && r.plainObjects ? Object.create(null) : {}, o = 0; o < e.length; ++o) {
          void 0 !== e[o] && (t[o] = e[o]);
        }return t;
      },
          merge = function e(r, t, o) {
        if (!t) return r;if ("object" != (typeof t === "undefined" ? "undefined" : _typeof(t))) {
          if (Array.isArray(r)) r.push(t);else {
            if (!r || "object" != (typeof r === "undefined" ? "undefined" : _typeof(r))) return [r, t];(o && (o.plainObjects || o.allowPrototypes) || !has.call(Object.prototype, t)) && (r[t] = !0);
          }return r;
        }if (!r || "object" != (typeof r === "undefined" ? "undefined" : _typeof(r))) return [r].concat(t);var a = r;return Array.isArray(r) && !Array.isArray(t) && (a = arrayToObject(r, o)), Array.isArray(r) && Array.isArray(t) ? (t.forEach(function (t, a) {
          if (has.call(r, a)) {
            var n = r[a];n && "object" == (typeof n === "undefined" ? "undefined" : _typeof(n)) && t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) ? r[a] = e(n, t, o) : r.push(t);
          } else r[a] = t;
        }), r) : Object.keys(t).reduce(function (r, a) {
          var n = t[a];return has.call(r, a) ? r[a] = e(r[a], n, o) : r[a] = n, r;
        }, a);
      },
          assign = function assign(e, r) {
        return Object.keys(r).reduce(function (e, t) {
          return e[t] = r[t], e;
        }, e);
      },
          decode = function decode(e) {
        try {
          return decodeURIComponent(e.replace(/\+/g, " "));
        } catch (r) {
          return e;
        }
      },
          encode = function encode(e) {
        if (0 === e.length) return e;for (var r = "string" == typeof e ? e : String(e), t = "", o = 0; o < r.length; ++o) {
          var a = r.charCodeAt(o);45 === a || 46 === a || 95 === a || 126 === a || a >= 48 && a <= 57 || a >= 65 && a <= 90 || a >= 97 && a <= 122 ? t += r.charAt(o) : a < 128 ? t += hexTable[a] : a < 2048 ? t += hexTable[192 | a >> 6] + hexTable[128 | 63 & a] : a < 55296 || a >= 57344 ? t += hexTable[224 | a >> 12] + hexTable[128 | a >> 6 & 63] + hexTable[128 | 63 & a] : (o += 1, a = 65536 + ((1023 & a) << 10 | 1023 & r.charCodeAt(o)), t += hexTable[240 | a >> 18] + hexTable[128 | a >> 12 & 63] + hexTable[128 | a >> 6 & 63] + hexTable[128 | 63 & a]);
        }return t;
      },
          compact = function compact(e) {
        for (var r = [{ obj: { o: e }, prop: "o" }], t = [], o = 0; o < r.length; ++o) {
          for (var a = r[o], n = a.obj[a.prop], c = Object.keys(n), u = 0; u < c.length; ++u) {
            var i = c[u],
                p = n[i];"object" == (typeof p === "undefined" ? "undefined" : _typeof(p)) && null !== p && -1 === t.indexOf(p) && (r.push({ obj: n, prop: i }), t.push(p));
          }
        }return compactQueue(r);
      },
          isRegExp = function isRegExp(e) {
        return "[object RegExp]" === Object.prototype.toString.call(e);
      },
          isBuffer = function isBuffer(e) {
        return null !== e && void 0 !== e && !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
      };module.exports = { arrayToObject: arrayToObject, assign: assign, compact: compact, decode: decode, encode: encode, isBuffer: isBuffer, isRegExp: isRegExp, merge: merge };
    }, {}], 16: [function (_dereq_, module, exports) {
      "use strict";
      function getBody(t) {
        return t ? "utf8" === t ? this.then(getBodyUTF8) : this.then(getBodyWithEncoding(t)) : this.then(getBodyBinary);
      }function getBodyWithEncoding(t) {
        return function (e) {
          return e.getBody(t);
        };
      }function getBodyBinary(t) {
        return t.getBody();
      }function getBodyUTF8(t) {
        return t.getBody("utf8");
      }function toResponsePromise(t) {
        return t.getBody = getBody, t;
      }exports.__esModule = !0;var Promise = _dereq_("promise");exports.default = toResponsePromise, exports.ResponsePromise = void 0;
    }, { "promise": 19 }], 17: [function (_dereq_, module, exports) {
      "use strict";
      function request(e, t, r) {
        return ResponsePromise_1.default(new Promise(function (o, s) {
          function n(r, i) {
            request(e, t, { qs: i.qs, headers: i.headers, timeout: i.timeout }).nodeify(function (e, t) {
              var a = !!(e || t.statusCode >= 400);if ("function" == typeof i.retry && (a = i.retry(e, t, r + 1)), r >= (i.maxRetries || 5) && (a = !1), a) {
                var u = i.retryDelay;"function" == typeof i.retryDelay && (u = i.retryDelay(e, t, r + 1)), u = u || 200, setTimeout(function () {
                  n(r + 1, i);
                }, u);
              } else e ? s(e) : o(t);
            });
          }var i = new XMLHttpRequest();if ("string" != typeof e) throw new TypeError("The method must be a string.");if ("string" != typeof t) throw new TypeError("The URL/path must be a string.");if (null == r && (r = {}), "object" != (typeof r === "undefined" ? "undefined" : _typeof(r))) throw new TypeError("Options must be an object (or null).");if (e = e.toUpperCase(), r.retry && "GET" === e) return n(0, r);var a,
              u = r.headers || {};if (!(!(a = /^([\w-]+:)?\/\/([^\/]+)/.exec(t)) || a[2] == location.host) || (u = __assign({}, u, { "X-Requested-With": "XMLHttpRequest" })), r.qs && (t = handle_qs_1.default(t, r.qs)), r.json && (r.body = JSON.stringify(r.json), u = __assign({}, u, { "Content-Type": "application/json" })), r.form && (r.body = r.form), r.timeout) {
            i.timeout = r.timeout;var p = Date.now();i.ontimeout = function () {
              var e = Date.now() - p,
                  t = new Error("Request timed out after " + e + "ms");t.timeout = !0, t.duration = e, s(t);
            };
          }i.onreadystatechange = function () {
            if (4 === i.readyState) {
              var e = {};i.getAllResponseHeaders().split("\r\n").forEach(function (t) {
                var r = t.split(":");r.length > 1 && (e[r[0].toLowerCase()] = r.slice(1).join(":").trim());
              });var r = new GenericResponse(i.status, e, i.responseText, t);o(r);
            }
          }, i.open(e, t, !0);for (var f in u) {
            i.setRequestHeader(f, u[f]);
          }i.send(r.body ? r.body : null);
        }));
      }var __assign = this && this.__assign || Object.assign || function (e) {
        for (var t, r = 1, o = arguments.length; r < o; r++) {
          t = arguments[r];for (var s in t) {
            Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
          }
        }return e;
      };exports.__esModule = !0;var GenericResponse = _dereq_("http-response-object"),
          Promise = _dereq_("promise"),
          ResponsePromise_1 = _dereq_("./ResponsePromise");exports.ResponsePromise = ResponsePromise_1.ResponsePromise;var handle_qs_1 = _dereq_("./handle-qs"),
          fd = FormData;exports.FormData = fd, exports.default = request, module.exports = request, module.exports.default = request, module.exports.FormData = fd;
    }, { "./ResponsePromise": 16, "./handle-qs": 18, "http-response-object": 10, "promise": 19 }], 18: [function (_dereq_, module, exports) {
      "use strict";
      function handleQs(s, e) {
        var r = s.split("?"),
            t = r[0],
            i = r[1],
            l = (i || "").split("#")[0],
            n = i && i.split("#").length > 1 ? "#" + i.split("#")[1] : "",
            a = qs_1.parse(l);for (var p in e) {
          a[p] = e[p];
        }return l = qs_1.stringify(a), "" !== l && (l = "?" + l), t + l + n;
      }exports.__esModule = !0;var qs_1 = _dereq_("qs");exports.default = handleQs;
    }, { "qs": 12 }], 19: [function (_dereq_, module, exports) {
      "use strict";
      module.exports = _dereq_("./lib");
    }, { "./lib": 24 }], 20: [function (_dereq_, module, exports) {
      "use strict";
      function noop() {}function getThen(e) {
        try {
          return e.then;
        } catch (e) {
          return LAST_ERROR = e, IS_ERROR;
        }
      }function tryCallOne(e, n) {
        try {
          return e(n);
        } catch (e) {
          return LAST_ERROR = e, IS_ERROR;
        }
      }function tryCallTwo(e, n, o) {
        try {
          e(n, o);
        } catch (e) {
          return LAST_ERROR = e, IS_ERROR;
        }
      }function Promise(e) {
        if ("object" != _typeof(this)) throw new TypeError("Promises must be constructed via new");if ("function" != typeof e) throw new TypeError("Promise constructor's argument is not a function");this._75 = 0, this._83 = 0, this._18 = null, this._38 = null, e !== noop && doResolve(e, this);
      }function safeThen(e, n, o) {
        return new e.constructor(function (r, t) {
          var i = new Promise(noop);i.then(r, t), handle(e, new Handler(n, o, i));
        });
      }function handle(e, n) {
        for (; 3 === e._83;) {
          e = e._18;
        }if (Promise._47 && Promise._47(e), 0 === e._83) return 0 === e._75 ? (e._75 = 1, void (e._38 = n)) : 1 === e._75 ? (e._75 = 2, void (e._38 = [e._38, n])) : void e._38.push(n);handleResolved(e, n);
      }function handleResolved(e, n) {
        asap(function () {
          var o = 1 === e._83 ? n.onFulfilled : n.onRejected;if (null === o) return void (1 === e._83 ? resolve(n.promise, e._18) : reject(n.promise, e._18));var r = tryCallOne(o, e._18);r === IS_ERROR ? reject(n.promise, LAST_ERROR) : resolve(n.promise, r);
        });
      }function resolve(e, n) {
        if (n === e) return reject(e, new TypeError("A promise cannot be resolved with itself."));if (n && ("object" == (typeof n === "undefined" ? "undefined" : _typeof(n)) || "function" == typeof n)) {
          var o = getThen(n);if (o === IS_ERROR) return reject(e, LAST_ERROR);if (o === e.then && n instanceof Promise) return e._83 = 3, e._18 = n, void finale(e);if ("function" == typeof o) return void doResolve(o.bind(n), e);
        }e._83 = 1, e._18 = n, finale(e);
      }function reject(e, n) {
        e._83 = 2, e._18 = n, Promise._71 && Promise._71(e, n), finale(e);
      }function finale(e) {
        if (1 === e._75 && (handle(e, e._38), e._38 = null), 2 === e._75) {
          for (var n = 0; n < e._38.length; n++) {
            handle(e, e._38[n]);
          }e._38 = null;
        }
      }function Handler(e, n, o) {
        this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof n ? n : null, this.promise = o;
      }function doResolve(e, n) {
        var o = !1,
            r = tryCallTwo(e, function (e) {
          o || (o = !0, resolve(n, e));
        }, function (e) {
          o || (o = !0, reject(n, e));
        });o || r !== IS_ERROR || (o = !0, reject(n, LAST_ERROR));
      }var asap = _dereq_("asap/raw"),
          LAST_ERROR = null,
          IS_ERROR = {};module.exports = Promise, Promise._47 = null, Promise._71 = null, Promise._44 = noop, Promise.prototype.then = function (e, n) {
        if (this.constructor !== Promise) return safeThen(this, e, n);var o = new Promise(noop);return handle(this, new Handler(e, n, o)), o;
      };
    }, { "asap/raw": 7 }], 21: [function (_dereq_, module, exports) {
      "use strict";
      var Promise = _dereq_("./core.js");module.exports = Promise, Promise.prototype.done = function (t, e) {
        (arguments.length ? this.then.apply(this, arguments) : this).then(null, function (t) {
          setTimeout(function () {
            throw t;
          }, 0);
        });
      };
    }, { "./core.js": 20 }], 22: [function (_dereq_, module, exports) {
      "use strict";
      function valuePromise(e) {
        var r = new Promise(Promise._44);return r._83 = 1, r._18 = e, r;
      }var Promise = _dereq_("./core.js");module.exports = Promise;var TRUE = valuePromise(!0),
          FALSE = valuePromise(!1),
          NULL = valuePromise(null),
          UNDEFINED = valuePromise(void 0),
          ZERO = valuePromise(0),
          EMPTYSTRING = valuePromise("");Promise.resolve = function (e) {
        if (e instanceof Promise) return e;if (null === e) return NULL;if (void 0 === e) return UNDEFINED;if (!0 === e) return TRUE;if (!1 === e) return FALSE;if (0 === e) return ZERO;if ("" === e) return EMPTYSTRING;if ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) || "function" == typeof e) try {
          var r = e.then;if ("function" == typeof r) return new Promise(r.bind(e));
        } catch (e) {
          return new Promise(function (r, n) {
            n(e);
          });
        }return valuePromise(e);
      }, Promise.all = function (e) {
        var r = Array.prototype.slice.call(e);return new Promise(function (e, n) {
          function o(i, u) {
            if (u && ("object" == (typeof u === "undefined" ? "undefined" : _typeof(u)) || "function" == typeof u)) {
              if (u instanceof Promise && u.then === Promise.prototype.then) {
                for (; 3 === u._83;) {
                  u = u._18;
                }return 1 === u._83 ? o(i, u._18) : (2 === u._83 && n(u._18), void u.then(function (e) {
                  o(i, e);
                }, n));
              }var f = u.then;if ("function" == typeof f) {
                return void new Promise(f.bind(u)).then(function (e) {
                  o(i, e);
                }, n);
              }
            }r[i] = u, 0 == --t && e(r);
          }if (0 === r.length) return e([]);for (var t = r.length, i = 0; i < r.length; i++) {
            o(i, r[i]);
          }
        });
      }, Promise.reject = function (e) {
        return new Promise(function (r, n) {
          n(e);
        });
      }, Promise.race = function (e) {
        return new Promise(function (r, n) {
          e.forEach(function (e) {
            Promise.resolve(e).then(r, n);
          });
        });
      }, Promise.prototype.catch = function (e) {
        return this.then(null, e);
      };
    }, { "./core.js": 20 }], 23: [function (_dereq_, module, exports) {
      "use strict";
      var Promise = _dereq_("./core.js");module.exports = Promise, Promise.prototype.finally = function (e) {
        return this.then(function (r) {
          return Promise.resolve(e()).then(function () {
            return r;
          });
        }, function (r) {
          return Promise.resolve(e()).then(function () {
            throw r;
          });
        });
      };
    }, { "./core.js": 20 }], 24: [function (_dereq_, module, exports) {
      "use strict";
      module.exports = _dereq_("./core.js"), _dereq_("./done.js"), _dereq_("./finally.js"), _dereq_("./es6-extensions.js"), _dereq_("./node-extensions.js"), _dereq_("./synchronous.js");
    }, { "./core.js": 20, "./done.js": 21, "./es6-extensions.js": 22, "./finally.js": 23, "./node-extensions.js": 25, "./synchronous.js": 26 }], 25: [function (_dereq_, module, exports) {
      "use strict";
      function denodeifyWithCount(n, r) {
        for (var e = [], t = 0; t < r; t++) {
          e.push("a" + t);
        }var o = ["return function (" + e.join(",") + ") {", "var self = this;", "return new Promise(function (rs, rj) {", "var res = fn.call(", ["self"].concat(e).concat([callbackFn]).join(","), ");", "if (res &&", '(typeof res === "object" || typeof res === "function") &&', 'typeof res.then === "function"', ") {rs(res);}", "});", "};"].join("");return Function(["Promise", "fn"], o)(Promise, n);
      }function denodeifyWithoutCount(n) {
        for (var r = Math.max(n.length - 1, 3), e = [], t = 0; t < r; t++) {
          e.push("a" + t);
        }var o = ["return function (" + e.join(",") + ") {", "var self = this;", "var args;", "var argLength = arguments.length;", "if (arguments.length > " + r + ") {", "args = new Array(arguments.length + 1);", "for (var i = 0; i < arguments.length; i++) {", "args[i] = arguments[i];", "}", "}", "return new Promise(function (rs, rj) {", "var cb = " + callbackFn + ";", "var res;", "switch (argLength) {", e.concat(["extra"]).map(function (n, r) {
          return "case " + r + ":res = fn.call(" + ["self"].concat(e.slice(0, r)).concat("cb").join(",") + ");break;";
        }).join(""), "default:", "args[argLength] = cb;", "res = fn.apply(self, args);", "}", "if (res &&", '(typeof res === "object" || typeof res === "function") &&', 'typeof res.then === "function"', ") {rs(res);}", "});", "};"].join("");return Function(["Promise", "fn"], o)(Promise, n);
      }var Promise = _dereq_("./core.js"),
          asap = _dereq_("asap");module.exports = Promise, Promise.denodeify = function (n, r) {
        return "number" == typeof r && r !== 1 / 0 ? denodeifyWithCount(n, r) : denodeifyWithoutCount(n);
      };var callbackFn = "function (err, res) {if (err) { rj(err); } else { rs(res); }}";Promise.nodeify = function (n) {
        return function () {
          var r = Array.prototype.slice.call(arguments),
              e = "function" == typeof r[r.length - 1] ? r.pop() : null,
              t = this;try {
            return n.apply(this, arguments).nodeify(e, t);
          } catch (n) {
            if (null === e || void 0 === e) return new Promise(function (r, e) {
              e(n);
            });asap(function () {
              e.call(t, n);
            });
          }
        };
      }, Promise.prototype.nodeify = function (n, r) {
        if ("function" != typeof n) return this;this.then(function (e) {
          asap(function () {
            n.call(r, null, e);
          });
        }, function (e) {
          asap(function () {
            n.call(r, e);
          });
        });
      };
    }, { "./core.js": 20, "asap": 6 }], 26: [function (_dereq_, module, exports) {
      "use strict";
      var Promise = _dereq_("./core.js");module.exports = Promise, Promise.enableSynchronous = function () {
        Promise.prototype.isPending = function () {
          return 0 == this.getState();
        }, Promise.prototype.isFulfilled = function () {
          return 1 == this.getState();
        }, Promise.prototype.isRejected = function () {
          return 2 == this.getState();
        }, Promise.prototype.getValue = function () {
          if (3 === this._83) return this._18.getValue();if (!this.isFulfilled()) throw new Error("Cannot get a value of an unfulfilled promise.");return this._18;
        }, Promise.prototype.getReason = function () {
          if (3 === this._83) return this._18.getReason();if (!this.isRejected()) throw new Error("Cannot get a rejection reason of a non-rejected promise.");return this._18;
        }, Promise.prototype.getState = function () {
          return 3 === this._83 ? this._18.getState() : -1 === this._83 || -2 === this._83 ? 0 : this._83;
        };
      }, Promise.disableSynchronous = function () {
        Promise.prototype.isPending = void 0, Promise.prototype.isFulfilled = void 0, Promise.prototype.isRejected = void 0, Promise.prototype.getValue = void 0, Promise.prototype.getReason = void 0, Promise.prototype.getState = void 0;
      };
    }, { "./core.js": 20 }], 27: [function (_dereq_, module, exports) {
      function Traverse(e) {
        this.value = e;
      }function walk(e, t, r) {
        var o = [],
            n = [],
            a = !0;return function e(i) {
          function c() {
            if ("object" == _typeof(l.node) && null !== l.node) {
              l.keys && l.node_ === l.node || (l.keys = objectKeys(l.node)), l.isLeaf = 0 == l.keys.length;for (var e = 0; e < n.length; e++) {
                if (n[e].node_ === i) {
                  l.circular = n[e];break;
                }
              }
            } else l.isLeaf = !0, l.keys = null;l.notLeaf = !l.isLeaf, l.notRoot = !l.isRoot;
          }var s = r ? copy(i) : i,
              u = {},
              f = !0,
              l = { node: s, node_: i, path: [].concat(o), parent: n[n.length - 1], parents: n, key: o.slice(-1)[0], isRoot: 0 === o.length, level: o.length, circular: null, update: function update(e, t) {
              l.isRoot || (l.parent.node[l.key] = e), l.node = e, t && (f = !1);
            }, delete: function _delete(e) {
              delete l.parent.node[l.key], e && (f = !1);
            }, remove: function remove(e) {
              isArray(l.parent.node) ? l.parent.node.splice(l.key, 1) : delete l.parent.node[l.key], e && (f = !1);
            }, keys: null, before: function before(e) {
              u.before = e;
            }, after: function after(e) {
              u.after = e;
            }, pre: function pre(e) {
              u.pre = e;
            }, post: function post(e) {
              u.post = e;
            }, stop: function stop() {
              a = !1;
            }, block: function block() {
              f = !1;
            } };if (!a) return l;c();var p = t.call(l, l.node);return void 0 !== p && l.update && l.update(p), u.before && u.before.call(l, l.node), f ? ("object" != _typeof(l.node) || null === l.node || l.circular || (n.push(l), c(), forEach(l.keys, function (t, n) {
            o.push(t), u.pre && u.pre.call(l, l.node[t], t);var a = e(l.node[t]);r && hasOwnProperty.call(l.node, t) && (l.node[t] = a.node), a.isLast = n == l.keys.length - 1, a.isFirst = 0 == n, u.post && u.post.call(l, a), o.pop();
          }), n.pop()), u.after && u.after.call(l, l.node), l) : l;
        }(e).node;
      }function copy(e) {
        if ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && null !== e) {
          var t;if (isArray(e)) t = [];else if (isDate(e)) t = new Date(e.getTime ? e.getTime() : e);else if (isRegExp(e)) t = new RegExp(e);else if (isError(e)) t = { message: e.message };else if (isBoolean(e)) t = new Boolean(e);else if (isNumber(e)) t = new Number(e);else if (isString(e)) t = new String(e);else if (Object.create && Object.getPrototypeOf) t = Object.create(Object.getPrototypeOf(e));else if (e.constructor === Object) t = {};else {
            var r = e.constructor && e.constructor.prototype || e.__proto__ || {},
                o = function o() {};o.prototype = r, t = new o();
          }return forEach(objectKeys(e), function (r) {
            t[r] = e[r];
          }), t;
        }return e;
      }function toS(e) {
        return Object.prototype.toString.call(e);
      }function isDate(e) {
        return "[object Date]" === toS(e);
      }function isRegExp(e) {
        return "[object RegExp]" === toS(e);
      }function isError(e) {
        return "[object Error]" === toS(e);
      }function isBoolean(e) {
        return "[object Boolean]" === toS(e);
      }function isNumber(e) {
        return "[object Number]" === toS(e);
      }function isString(e) {
        return "[object String]" === toS(e);
      }var traverse = module.exports = function (e) {
        return new Traverse(e);
      };Traverse.prototype.get = function (e) {
        for (var t = this.value, r = 0; r < e.length; r++) {
          var o = e[r];if (!t || !hasOwnProperty.call(t, o)) {
            t = void 0;break;
          }t = t[o];
        }return t;
      }, Traverse.prototype.has = function (e) {
        for (var t = this.value, r = 0; r < e.length; r++) {
          var o = e[r];if (!t || !hasOwnProperty.call(t, o)) return !1;t = t[o];
        }return !0;
      }, Traverse.prototype.set = function (e, t) {
        for (var r = this.value, o = 0; o < e.length - 1; o++) {
          var n = e[o];hasOwnProperty.call(r, n) || (r[n] = {}), r = r[n];
        }return r[e[o]] = t, t;
      }, Traverse.prototype.map = function (e) {
        return walk(this.value, e, !0);
      }, Traverse.prototype.forEach = function (e) {
        return this.value = walk(this.value, e, !1), this.value;
      }, Traverse.prototype.reduce = function (e, t) {
        var r = 1 === arguments.length,
            o = r ? this.value : t;return this.forEach(function (t) {
          this.isRoot && r || (o = e.call(this, o, t));
        }), o;
      }, Traverse.prototype.paths = function () {
        var e = [];return this.forEach(function (t) {
          e.push(this.path);
        }), e;
      }, Traverse.prototype.nodes = function () {
        var e = [];return this.forEach(function (t) {
          e.push(this.node);
        }), e;
      }, Traverse.prototype.clone = function () {
        var e = [],
            t = [];return function r(o) {
          for (var n = 0; n < e.length; n++) {
            if (e[n] === o) return t[n];
          }if ("object" == (typeof o === "undefined" ? "undefined" : _typeof(o)) && null !== o) {
            var a = copy(o);return e.push(o), t.push(a), forEach(objectKeys(o), function (e) {
              a[e] = r(o[e]);
            }), e.pop(), t.pop(), a;
          }return o;
        }(this.value);
      };var objectKeys = Object.keys || function (e) {
        var t = [];for (var r in e) {
          t.push(r);
        }return t;
      },
          isArray = Array.isArray || function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      },
          forEach = function forEach(e, t) {
        if (e.forEach) return e.forEach(t);for (var r = 0; r < e.length; r++) {
          t(e[r], r, e);
        }
      };forEach(objectKeys(Traverse.prototype), function (e) {
        traverse[e] = function (t) {
          var r = [].slice.call(arguments, 1),
              o = new Traverse(t);return o[e].apply(o, r);
        };
      });var hasOwnProperty = Object.hasOwnProperty || function (e, t) {
        return t in e;
      };
    }, {}], 28: [function (_dereq_, module, exports) {
      module.exports = { "version": "0.0.3" };
    }, {}], 29: [function (_dereq_, module, exports) {
      "use strict";
      var Chroma = _dereq_("chroma-js"),
          UtilsStatics = _dereq_("../geo/utilsStatics"),
          Colorizator = function Colorizator() {
        this.palettes = ["OrRd", "BuGn", "BuPu", "GnBu", "PuBu", "PuBuGn", "PuRd", "RdPu", "YlGn", "YlGnBu", "YlOrBr", "YlOrRd", "BrBG", "PRGn", "PuOr", "RdGy", "RdYlBu", "RdYlGn"], this.maxBrewerPalettes = this.palettes.length - 1, this.maxRangsColor = 9, this.defaultNumber = 5, this.Utils = new UtilsStatics();
      };Colorizator.prototype.getRandomColorFromArray = function () {
        var t = ["#000000", "#424242", "#636363", "#9C9C94", "#CEC6CE", "#EFEFEF", "#F7F7F7", "#FFFFFF", "#FF0000", "#FF9C00", "#FFFF00", "#00FF00", "#00FFFF", "#0000FF", "#9C00FF", "#FF00FF", "#F7C6CE", "#FFE7CE", "#FFEFC6", "#D6EFD6", "#CEDEE7", "#CEE7F7", "#D6D6E7", "#E7D6DE", "#E79C9C", "#FFC69C", "#FFE79C", "#B5D6A5", "#A5C6CE", "#9CC6EF", "#B5A5D6", "#D6A5BD", "#E76363", "#F7AD6B", "#FFD663", "#94BD7B", "#73A5AD", "#6BADDE", "#8C7BC6", "#C67BA5", "#CE0000", "#E79439", "#EFC631", "#6BA54A", "#4A7B8C", "#3984C6", "#634AA5", "#A54A7B", "#9C0000", "#B56308", "#BD9400", "#397B21", "#104A5A", "#085294", "#311873", "#731842", "#630000", "#7B3900", "#846300", "#295218", "#083139", "#003163", "#21104A", "#4A1031"];return t[Math.floor(Math.random() * t.length)];
      }, Colorizator.prototype.getRandomColor = function () {
        for (var t = "#", r = 0; r < 6; r++) {
          t += "0123456789ABCDEF"[Math.floor(16 * Math.random())];
        }return t;
      }, Colorizator.prototype.getRandomColorsFromNum = function (t) {
        for (var r = this, e = [], o = 0; o < t; o++) {
          e.push(r.getRandomColor());
        }return e;
      }, Colorizator.prototype.getOppositeGrayScaleColor = function (t) {
        var r = Chroma(t).luminance(),
            e = parseFloat(1 - r),
            o = Chroma("white").luminance(.7 * e).hex();return e < .86 ? o = "rgba(0,0,0,0.8)" : e > .87 && (o = "rgba(250,250,250,0.8)"), o;
      }, Colorizator.prototype.getColorArrayfromPositionBrewer = function (t, r) {
        return Chroma.brewer[this.palettes[this._checkBrewerPosition(r)]].slice(-this._checkNumRangs(t));
      }, Colorizator.prototype.getColorsScaleRanges = function (t, r, e) {
        return null === r || null === e ? this.getRandomColorsFromNum(t) : Chroma.scale([r, e]).mode("lch").colors(t);
      }, Colorizator.prototype._checkNumRangs = function (t) {
        return "number" == typeof t ? t > this.maxRangsColor ? this.maxRangsColor : t : this.defaultNumber;
      }, Colorizator.prototype._checkBrewerPosition = function (t) {
        return "number" == typeof t ? t > this.maxBrewerPalettes ? this.maxBrewerPalettes : t : this.defaultNumber;
      }, Colorizator.prototype._checkBrewerName = function (t) {
        return -1 !== this.palettes.indexOf(t) ? t : this.palettes[Math.floor(Math.random() * this.maxBrewerPalettes)];
      }, Colorizator.prototype.getColorArrayfromSelectedBrewer = function (t, r) {
        return Chroma.brewer[this._checkBrewerName(r)].slice(-this._checkNumRangs(t));
      }, Colorizator.prototype.convertRGBtoHex = function (t) {
        return Chroma(rgb).hex();
      }, Colorizator.prototype.generateHTMLBrewerPalettes = function (t, r) {
        var e = this,
            o = -15,
            i = "",
            a = [],
            s = "";return this.palettes.slice(0, this._checkBrewerPosition(t)).forEach(function (t, l) {
          Chroma.brewer[t] && (a = Chroma.brewer[t].slice(-e._checkNumRangs(r + 1)), s = 0 === l ? "selected" : "", i = i + '<div id="' + t + '" class="ramp ' + t + " " + s + '"><svg width="15" height="75">', o = -15, a.forEach(function (t) {
            o += 15, i = i + '<rect fill="' + t + '" width="15" height="15" y="' + o + '"></rect>';
          }), i += "</svg></div>");
        }), i;
      }, Colorizator.prototype.generateHTMLLegendColor = function (t, r, e, o) {
        for (var i = this, a = o || "legend_class", s = '<div class="' + a + '"> <h5>' + e + "</h5>", l = t.length, n = parseInt(100 / l), h = 0; h < l; h++) {
          var u = r[h],
              C = "",
              c = "";if ("string" == typeof u && -1 !== u.indexOf("-") ? (C = u.split("-"), c = i.Utils.converToNumberIfPossible(C[0].trim(), 0), s = s + '<div style="float:left;width:' + n + '%" class="w-15"><div style="font-size:0.85em">' + c) : s = !isNaN(parseInt(u)) && l < i.maxRangsColor ? s + '<div style="float:left;width:' + n + '%" class="w-15"><div style="font-size:0.85em">' + u : s + '<div class="uniqueValues"  class="w-15"><div style="font-size:0.85em">' + u, h === l - 1) {
            var F = r[h + 1];F && void 0 !== F || (F = ""), "number" == typeof F && (F = F.toFixed(1)), s = s + '<span style="float: right;font-size:0.85em">' + F + "</span>";
          }s += "</div>", s = s + '<div style="width:100%;height:20px;border:1px solid white;background-color:' + t[h] + '"></div></div> ';
        }return s += "</div>";
      }, module.exports = Colorizator;
    }, { "../geo/utilsStatics": 34, "chroma-js": 8 }], 30: [function (_dereq_, module, exports) {
      "use strict";
      var BridgeStatics = _dereq_("./bridgeStatics"),
          UtilsStatics = _dereq_("./utilsStatics"),
          ArrayStatics = function ArrayStatics(t) {
        if (this.arrayColumn = t, this.bridgeStatics = null, this.stats = {}, this.utilsStatistis = new UtilsStatics(), null === this.arrayColumn || !Array.isArray(this.arrayColumn)) throw new Error("No options provided:arrayColumn needed");this.bridgeStatics = new BridgeStatics(this.utilsStatistis.checkArrayValues(this.arrayColumn));
      };ArrayStatics.prototype.getUniqueValues = function () {
        return this.bridgeStatics.getClassUniqueValues();
      }, ArrayStatics.prototype.getBasicsStats = function (t) {
        return this.stats = { basics: this.bridgeStatics.getBasicsStats(t) }, this.stats;
      }, ArrayStatics.prototype.getStatsFromRangesColorsArray = function (t, s) {
        if ("number" == typeof t && Array.isArray(s)) return this.stats = { classification: this.bridgeStatics.setClassificationStats(t), colors: this.bridgeStatics.setColorstoStats(s), basics: this.bridgeStatics.getBasicsStats() }, this.stats;throw new Error("Invalid parameters provided: numRanges or arrayColors");
      }, module.exports = ArrayStatics;
    }, { "./bridgeStatics": 31, "./utilsStatics": 34 }], 31: [function (_dereq_, module, exports) {
      "use strict";
      var GeoStats = _dereq_("../vendor/geostats"),
          BridgeStatics = function BridgeStatics(t) {
        if (!t) throw new Error("Invalid array provided");this.geoStats = new GeoStats(t), this.stats = {}, this.geoStats.setPrecision(1), this.geoStats.silent = !0;
      };BridgeStatics.prototype.getClassUniqueValues = function () {
        return this.geoStats.getClassUniqueValues();
      }, BridgeStatics.prototype.setColorstoStats = function (t) {
        return this.geoStats.setColors(t), this.stats.colors = { colors: this.geoStats.colors }, this.stats.colors;
      }, BridgeStatics.prototype.getValueFromRangePosition = function (t) {
        return this.geoStats.getRangeNum(t);
      }, BridgeStatics.prototype.setClassificationStats = function (t) {
        this.stats.classification = { quantile: this.geoStats.getQuantile(t), equals: this.geoStats.getEqInterval(t), uniques: this.geoStats.getClassUniqueValues(), ranges: this.geoStats.getRanges(), list: this.geoStats.getSortedlist() };try {
          this.stats.classification.jenks = this.geoStats.getJenks(t);
        } catch (s) {
          this.stats.classification.jenks = this.geoStats.getQuantile(t);
        }return this.stats.classification;
      }, BridgeStatics.prototype.isValid = function (t, s) {
        return "number" != typeof t || Number.isNaN(t) ? t : parseFloat(t.toFixed(s));
      }, BridgeStatics.prototype.getBasicsStats = function (t) {
        var s = 1;return "number" == typeof t && (s = parseInt(t)), this.stats.basics = { min: this.isValid(this.geoStats.min(), s), max: this.isValid(this.geoStats.max(), s), sum: this.isValid(this.geoStats.sum(), s), pop: this.isValid(this.geoStats.pop(), s), mean: this.isValid(this.geoStats.mean(), s), median: this.isValid(this.geoStats.median(), s), stddev: this.isValid(this.geoStats.stddev(), s), cov: this.isValid(this.geoStats.cov(), s), diff: this.isValid(this.geoStats.max() - this.geoStats.min(), s) }, this.stats.basics;
      }, module.exports = BridgeStatics;
    }, { "../vendor/geostats": 38 }], 32: [function (_dereq_, module, exports) {
      "use strict";
      var BridgeStatics = _dereq_("./bridgeStatics"),
          UtilsStatics = _dereq_("./utilsStatics"),
          CSVStatics = function CSVStatics(t, s) {
        if (this.numCSVColumn = s, this.arrayCSV = t, this.bridgeStatics = null, this.stats = {}, this.utilsStatistis = new UtilsStatics(), null === this.numCSVColumn || !Array.isArray(this.arrayCSV)) throw new Error("No options provided: arrayCSV data and numCSVColumn");this.bridgeStatics = new BridgeStatics(this.getColumFromCSV(this.numCSVColumn, this.arrayCSV));
      };CSVStatics.prototype.getUniqueValues = function () {
        return this.bridgeStatics.getClassUniqueValues();
      }, CSVStatics.prototype.getStatsFromRangesColorsCSV = function (t, s) {
        if ("number" == typeof t && Array.isArray(s)) return this.stats = { classification: this.bridgeStatics.setClassificationStats(t), colors: this.bridgeStatics.setColorstoStats(s), basics: this.bridgeStatics.getBasicsStats() }, this.stats;throw new Error("Invalid parameters provided: numRanges or arrayColors");
      }, CSVStatics.prototype.getColumFromCSV = function (t, s, i) {
        var r = this;void 0 === i && (i = !1);var a = [];if ("number" == typeof t && Array.isArray(s)) {
          for (var e = 0; e < s.length; e++) {
            if (e > 0) {
              var o = s[e][t];r.utilsStatistis.checkIfExistsValue(o) && (i ? a.push(r.utilsStatistis.forceToNumber(o)) : a.push(o));
            }
          }return a;
        }throw new Error("Invalid parameters provided: dataCSV AND numColum");
      }, module.exports = CSVStatics;
    }, { "./bridgeStatics": 31, "./utilsStatics": 34 }], 33: [function (_dereq_, module, exports) {
      "use strict";
      var BridgeStatics = _dereq_("./bridgeStatics"),
          UtilsStatics = _dereq_("./utilsStatics"),
          GeoJSONStatistics = function GeoJSONStatistics(t, e) {
        if (this.geoJSON = t || null, this.keyField = e || null, this.bridgeStatics = null, this.stats = {}, this.Utils = new UtilsStatics(), this.geomType = null, this.maxFetauresToCount = 5e3, null === this.geoJSON || "object" != _typeof(this.geoJSON) || null === this.keyField) throw new Error("Invalid parameters provided: geoJSON AND keyField");this.bridgeStatics = new BridgeStatics(this.getColumnFromGEOJSON(this.keyField, this.geoJSON));
      };GeoJSONStatistics.prototype.getUniqueValues = function () {
        return this.bridgeStatics.getClassUniqueValues();
      }, GeoJSONStatistics.prototype.getStatsFromRangesColorsGeoJSON = function (t, e) {
        if ("number" == typeof t && Array.isArray(e)) return this.stats = { classification: this.bridgeStatics.setClassificationStats(t), colors: this.bridgeStatics.setColorstoStats(e), basics: this.bridgeStatics.getBasicsStats() }, this.stats;throw new Error("Invalid parameters provided: numRanges or arrayColors");
      }, GeoJSONStatistics.prototype.getColumnFromGEOJSON = function (t, e, s) {
        var i = this;void 0 === s && (s = !1);var r = [],
            o = 0;if (null !== this.geoJSON && "object" == _typeof(this.geoJSON) && null !== this.keyField) {
          var a = this.Utils.checkType(this.geoJSON.features[0].properties[t]);for (var l in e.features) {
            if (o < i.maxFetauresToCount) {
              var n = e.features[l];i.Utils.checkIfExistsValue(n.properties[t]) && (s ? r.push(i.Utils.forceToNumber(n.properties[t])) : s || "string" !== a || isNaN(parseInt(n.properties[t])) ? r.push(n.properties[t]) : r.push("# " + n.properties[t].toString()));
            }o += 1;
          }return r;
        }throw new Error("Invalid parameters provided: geoJSON AND keyField");
      }, GeoJSONStatistics.prototype._getColumFromGEOJSONFilter = function (t, e, s, i) {
        var r = this,
            o = [];for (var a in e.features) {
          var l = e.features[a];r.Utils.checkIfExistsValue(l.properties[t]) && l.properties[s] < i && o.push(l.properties[t]);
        }return o;
      }, module.exports = GeoJSONStatistics;
    }, { "./bridgeStatics": 31, "./utilsStatics": 34 }], 34: [function (_dereq_, module, exports) {
      "use strict";
      var UtilsStatics = function UtilsStatics() {};UtilsStatics.prototype.forceToNumber = function (t) {
        return isNaN(parseFloat(t)) || "string" != typeof t ? "number" == typeof t && "undefined" !== t || (t = -100) : (t = t.replace(",", "."), t = parseFloat(t)), t;
      }, UtilsStatics.prototype.checkArrayValues = function (t) {
        for (var e = this, r = [], o = 0; o < t.length; o++) {
          e.checkIfExistsValue(t[o]) && r.push(t[o]);
        }return r;
      }, UtilsStatics.prototype.converToNumberIfPossible = function (t, e) {
        var r = e || 0;return isNaN(parseFloat(t)) || "string" != typeof t ? "number" == typeof t && "undefined" !== t || (t = t) : (t = t.replace(",", "."), t = parseFloat(t).toFixed(r)), t;
      }, UtilsStatics.prototype.checkType = function (t) {
        return typeof t === "undefined" ? "undefined" : _typeof(t);
      }, UtilsStatics.prototype.checkIfExistsValue = function (t) {
        return void 0 !== t && null !== t && "null" !== t && "" !== t;
      }, module.exports = UtilsStatics;
    }, {}], 35: [function (_dereq_, module, exports) {
      "use strict";
      var MapStyle = _dereq_("./map/mapStyle"),
          GeoJSONStatics = _dereq_("./geo/geoJSONStatics"),
          CSVStatics = _dereq_("./geo/csvStatics"),
          ArrayStatics = _dereq_("./geo/arrayStatics"),
          JsonToMap = _dereq_("./map/jsonToMap"),
          UtilsStatics = _dereq_("./geo/utilsStatics"),
          Colorizator = _dereq_("./color/colorizator"),
          Version = _dereq_("../package.json").version;module.exports = { Version: Version, MapStyle: MapStyle, GeoJSONStatics: GeoJSONStatics, CSVStatics: CSVStatics, ArrayStatics: ArrayStatics, UtilsStatics: UtilsStatics, Colorizator: Colorizator, JsonToMap: JsonToMap };
    }, { "../package.json": 28, "./color/colorizator": 29, "./geo/arrayStatics": 30, "./geo/csvStatics": 32, "./geo/geoJSONStatics": 33, "./geo/utilsStatics": 34, "./map/jsonToMap": 36, "./map/mapStyle": 37 }], 36: [function (_dereq_, module, exports) {
      "use strict";
      var request = _dereq_("then-request"),
          JsonToMap = function JsonToMap() {
        this.defaultMapOptions = { style: "https://tilemaps.icgc.cat/tileserver/styles/fosc.json", center: [2.9547, 41.854], container: "map", zoom: 10 }, this.JSON = null;
      };JsonToMap.prototype.getAsyncConfigJSON = function (t, e) {
        var o = this;return e = e || function () {}, new Promise(function (n, i) {
          null !== t && "string" == typeof t && -1 !== t.indexOf(".json") ? request("GET", t).done(function (t) {
            return 200 === t.statusCode && JSON.parse(t.getBody()) ? (o.JSON = JSON.parse(t.getBody()), n(o.JSON), e(o.JSON)) : (i(t), e(t));
          }) : i({ statusCode: 100, msg: "Invalid parameters provided: in pathJSON" });
        });
      }, JsonToMap.prototype.getConfigJSON = function () {
        return this.JSON;
      }, JsonToMap.prototype.getAsyncSourceGeoJSONFromPath = function (t, e) {
        var o = t;return e = e || function () {}, new Promise(function (n, i) {
          null !== t && "string" == typeof t ? request("GET", o).done(function (t) {
            200 === t.statusCode && JSON.parse(t.getBody()) ? (e(JSON.parse(t.getBody())), n(JSON.parse(t.getBody()))) : (i(t), e(t));
          }) : i({ statusCode: 100, msg: "No valid url" });
        });
      }, JsonToMap.prototype.getAsyncSourceGeoJSON = function (t) {
        if (null !== this.JSON && this.JSON.vieweroptions) {
          var e = this.JSON.vieweroptions.geojsonpath,
              o = this.JSON.vieweroptions.sourcename;return t = t || function () {}, new Promise(function (n, i) {
            request("GET", e).done(function (e) {
              if (200 === e.statusCode && JSON.parse(e.getBody())) {
                var s = { name: o, data: JSON.parse(e.getBody()) };n(s), t(s);
              } else i(e), t(e);
            });
          });
        }throw new Error("No JSON found");
      }, JsonToMap.prototype.getOptionsMap = function (t) {
        var e = {};if (null === this.JSON) return this.defaultMapOptions;try {
          return e.style = this.JSON.vieweroptions.style, e.center = [this.JSON.vieweroptions.initview.lon, this.JSON.vieweroptions.initview.lat], e.zoom = this.JSON.vieweroptions.initview.zoom, e.pitch = this.JSON.vieweroptions.initview.pitch, e.bearing = this.JSON.vieweroptions.initview.bearing, e.container = t, e.hash = !0, e;
        } catch (t) {
          return this.defaultMapOptions;
        }
      }, module.exports = JsonToMap;
    }, { "then-request": 17 }], 37: [function (_dereq_, module, exports) {
      "use strict";
      var Colorizator = _dereq_("../color/colorizator"),
          GeoJSONStatics = _dereq_("../geo/geoJSONStatics"),
          BridgeStatics = _dereq_("../geo/bridgeStatics"),
          UtilsStatics = _dereq_("../geo/utilsStatics"),
          GeoExtent = _dereq_("@mapbox/geojson-extent"),
          request = _dereq_("then-request"),
          MapStyle = function MapStyle(e) {
        this.colorizator = new Colorizator(), this.Utils = new UtilsStatics(), this.geoExtent = null, this.legendColors = [], this.legendRanges = [], this.haloTextColors = [], this.geostatstics = null, this.defaultMinZoom = 2, this.defaultMaxZoom = 18, this.defaultColor = "#FFCCDD", this.defaultVisualization = "visible", this.defaultFactor = 10, this.defaultHFactor = 100, this.defaultTextFactor = 1, this.exponetialTextFactor = 1.3, null !== e && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e.features ? (this.geoJSON = e, this.geomType = this.getGeomTypeFromGeoJSON(), this.fieldNames = this.getFieldNamesColumnFromGEOJSON(), this.fieldNames && this.fieldNames.length > 0 && this.generateGeoStatisticsFromField(this.fieldNames[0])) : (this.geoJSON = null, this.geomType = null, this.fieldNames = null);
      };MapStyle.prototype.getAsyncGeoJSON = function (e, r) {
        var t = this;return r = r || function () {}, new Promise(function (g, o) {
          null !== e && "string" == typeof e ? request("GET", e).done(function (e) {
            return 200 === e.statusCode && JSON.parse(e.getBody()) ? (t.geoJSON = JSON.parse(e.getBody()), t.geomType = t.getGeomTypeFromGeoJSON(), t.fieldNames = t.getFieldNamesColumnFromGEOJSON(), t.fieldNames && t.fieldNames.length > 0 && t.generateGeoStatisticsFromField(t.fieldNames[0]), g(e), r(e)) : (o(e), r(e));
          }) : o({ statusCode: 100, msg: "No GeoJSON path found" });
        });
      }, MapStyle.prototype.getGeomTypeFromGeoJSON = function () {
        try {
          if (null !== this.geoJSON && "object" == _typeof(this.geoJSON) && this.geoJSON.features) return this.geoJSON.features[0].geometry.type;throw new Error("Invalid: geoJSON");
        } catch (e) {
          return null;
        }
      }, MapStyle.prototype.getFieldNamesColumnFromGEOJSON = function () {
        var e = this,
            r = [],
            t = [];if (null !== this.geoJSON && "object" == _typeof(this.geoJSON) && this.geoJSON.features) {
          for (var g in e.geoJSON.features) {
            var o = e.geoJSON.features[g];for (var i in o.properties) {
              r.push(i);
            }
          }if (r.length > 0) {
            for (var b = new BridgeStatics(r), a = b.getClassUniqueValues(), n = 0; n < a.length; n++) {
              e.geoJSON.features[0].properties[a[n]] && t.push({ name: a[n], type: e.Utils.checkType(e.geoJSON.features[0].properties[a[n]]) });
            }return t;
          }throw new Error("The GeoJSON not contain field properties");
        }throw new Error("Invalid: geoJSON");
      }, MapStyle.prototype.getImplementedLayerTypes = function () {
        return { type: { circle: "Point", fillextrusion: "Polygon3D", symbol: "Text", fill: "Polygon", line: "Line" } };
      }, MapStyle.prototype.getLegendFromStyle = function (e, r) {
        return this.colorizator.generateHTMLLegendColor(this.legendColors, this.legendRanges, e, r);
      }, MapStyle.prototype.getFilterByDefault = function (e) {
        return ["!=", ["typeof", ["get", e]], "null"];
      }, MapStyle.prototype.generateGeoStatisticsFromField = function (e) {
        try {
          return this.geostatstics = new GeoJSONStatics(this.geoJSON, e), this.geostatstics;
        } catch (e) {
          throw new Error("No geostatistics created: " + e);
        }
      }, MapStyle.prototype.createStyleLayer = function (e, r, t, g, o, i, b, a, n) {
        var l = { id: r },
            s = this.getImplementedLayerTypes();return i = i || this.defaultMinZoom, o = o || this.defaultMaxZoom, g = g || "line", b = b || this.defaultColor, a = a || this.defaultVisualization, g && -1 !== g.indexOf(s.type.circle) ? l.style = { id: r, source: e, interactive: !0, type: "circle", minzoom: i, maxzoom: o, paint: { "circle-color": b, "circle-radius": ["interpolate", ["exponential", 1], ["zoom"], 3, .5, 15, 8] }, filter: ["!=", ["typeof", ["get", t]], "null"] } : -1 !== g.indexOf(s.type.fillextrusion) ? (n = n || this.defaultHFactor, l.style = { id: r, source: e, interactive: !0, type: "fill-extrusion", minzoom: i, maxzoom: o, paint: { "fill-extrusion-opacity": .9, "fill-extrusion-color": b, "fill-extrusion-height": 1 * n }, filter: ["!=", ["typeof", ["get", t]], "null"] }) : -1 !== g.indexOf(s.type.symbol) ? (n = n || this.defaultTextFactor, l.style = { id: r, source: e, interactive: !0, type: "symbol", minzoom: i, maxzoom: o, "text-allow-overlap": !0, "text-ignore-placement": !0, "symbol-spacing": 10, layout: { "text-field": "{" + t + "}", "text-font": ["Open Sans Bold"], "text-size": ["interpolate", ["exponential", 1], ["zoom"], 4, parseInt(12 * n), 8, parseInt(10 * n), 10, parseInt(10 * n), 14, parseInt(8 * n), 16, parseInt(6 * n), 18, parseInt(7 * n)], "symbol-placement": "point", "text-anchor": "top", "symbol-spacing": 750 }, paint: { "text-halo-color": "rgba(0,0,0,0.8)", "text-color": b, "text-halo-width": 1.5, "text-halo-blur": 1 }, filter: ["!=", ["typeof", ["get", t]], "null"] }) : -1 !== g.indexOf(s.type.line) ? l.style = { id: r, source: e, interactive: !0, type: "line", minzoom: i, maxzoom: o, layout: { "line-join": "round", "line-cap": "round" }, paint: { "line-width": 3, "line-color": b }, filter: ["!=", ["typeof", ["get", t]], "null"] } : -1 !== g.indexOf(s.type.fill) ? l.style = { id: r, source: e, interactive: !0, type: "fill", minzoom: i, maxzoom: o, paint: { "fill-opacity": .9, "fill-color": b }, filter: ["!=", ["typeof", ["get", t]], "null"] } : l.style = { id: r, source: e, interactive: !0, type: "circle", minzoom: i, maxzoom: o, paint: { "circle-color": "#ff0000", "circle-radius": ["interpolate", ["exponential", 1], ["zoom"], 1, .5, 10, 2] }, filter: ["!=", ["typeof", ["get", t]], "null"] }, l;
      }, MapStyle.prototype.setStyleFromPreDefinedRamTemperatureHeights = function (e) {
        return ["interpolate", ["exponential", 1], ["number", ["get", e]], -25, 0, -10, 10, -5, 15, 0, 100, 2, 200, 4, 400, 8, 800, 10, 1e3, 12, 1200, 14, 1400, 16, 1600, 18, 1800, 20, 2e3, 22, 2200, 24, 2600, 26, 2800, 28, 3200, 30, 3600, 32, 4e3, 34, 4400, 36, 5e3, 38, 5500, 40, 6e3, 42, 7e3, 44, 8e3, 46, 9e3, 48, 1e4, 50, 12e3];
      }, MapStyle.prototype.setStyleFromPreDefinedRamTemperatureInterpolateHeights = function (e) {
        return ["interpolate", ["linear"], ["zoom"], 4, ["*", ["number", ["get", e]], 100], 16, ["*", ["number", ["get", e]], 50]];
      }, MapStyle.prototype.setStyleTextSizeByFactorSize = function (e) {
        return e = e || this.defaultTextFactor, ["interpolate", ["exponential", 1], ["zoom"], 4, parseFloat(12 + e * this.exponetialTextFactor), 8, parseFloat(10 + e * this.exponetialTextFactor), 10, parseFloat(10 + e * this.exponetialTextFactor), 14, parseFloat(8 + e * this.exponetialTextFactor), 16, parseFloat(6 + e * this.exponetialTextFactor), 18, parseFloat(6 + e * this.exponetialTextFactor)];
      }, MapStyle.prototype.setStyleFromPreDefinedRamTemperatureColor = function (e) {
        return ["interpolate", ["exponential", 1], ["number", ["get", e]], -25, "#0000ff", -10, "#68a2ff", -5, "#68d9ff", 0, "#68ffff", 2, "#68ffe0", 4, "#68ff9d", 8, "#7DFF68", 10, "#B2FF2B", 12, "#B6FF29", 14, "#CEFF1B", 16, "#DFFF12", 18, "#F9FF03", 20, "#FFF500", 22, "#FFE200", 24, "#FFCC00", 26, "#ffb600", 28, "#ff9000", 30, "#ff7200", 32, "#ff5000", 34, "#ff3200", 36, "#ff0059", 38, "#ff0059", 40, "#ff0098", 42, "#d30480", 44, "#d004d3", 46, "#d004d3", 48, "#d004d3", 50, "#d004d3"];
      }, MapStyle.prototype.setStylesFromPredefinedScales = function (e, r) {
        var t = { TemperaturaMeteocat: ["interpolate", ["exponential", 1], ["number", ["get", e]], -18, "rgb(0,0,168)", -16, "rgb(66,22,202)", -14, "rgb(80,46,189)", -12, "rgb(93,69,175)", -10, "rgb(110,94,160)", -8, "rgb(100,0,100)", -6, "rgb(126,38,126)", -4, "rgb(155,79,155)", -2, "rgb(186,122,186)", 0, "rgb(205,150,205)", 2, "rgb(204,255,255)", 4, "rgb(164,236,239)", 6, "rgb(134,216,217)", 8, "rgb(106,194,209)", 10, "rgb(65,157,171)", 12, "rgb(1,134,45)", 14, "rgb(3,194,40)", 16, "rgb(0,255,64)", 18, "rgb(123,241,123)", 20, "rgb(201,255,148)", 22, "rgb(241,242,136)", 24, "rgb(241,207,101)", 26, "rgb(240,171,65)", 28, "rgb(240,138,31)", 30, "rgb(240,107,0)", 32, "rgb(255,102,102)", 34, "rgb(255,70,70)", 36, "rgb(255,0,0)", 38, "rgb(178,34,34)", 40, "rgb(155,0,0)", 42, "rgb(115,0,0)", 50, "rgb(79,0,0)"], VentMeteocat: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgb(18,244,244)", 5, "rgb(8,159,252)", 10, "rgb(14,81,248)", 20, "rgb(16,13,112)", 30, "rgb(95,255,0)", 40, "rgb(1,206,63)", 50, "rgb(56,144,0)", 60, "rgb(32,95,1)", 70, "rgb(255,255,0)", 80, "rgb(255,235,0)", 90, "rgb(255,170,0)", 100, "rgb(230,76,0)", 125, "rgb(255,0,0)", 150, "rgb(168,0,0)", 175, "rgb(115,0,0)", 1e3, "rgb(115,0,0)"], HRMeteocat: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgb(120,0,0)", 5, "rgb(153,0,0)", 10, "rgb(204,51,0)", 15, "rgb(255,0,0)", 20, "rgb(255,102,102)", 25, "rgb(255,102,51)", 30, "rgb(255,153,51)", 35, "rgb(255,204,0)", 40, "rgb(255,255,0)", 45, "rgb(153,255,0)", 50, "rgb(0,255,0)", 55, "rgb(20,204,20)", 60, "rgb(0,140,0)", 65, "rgb(0,255,200)", 70, "rgb(0,255,255)", 75, "rgb(0,150,250)", 80, "rgb(0,80,255)", 85, "rgb(0,0,255)", 90, "rgb(100,51,204)", 95, "rgb(153,0,153)", 100, "rgb(153,0,153)"], pptMeteocat: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgb(255,255,255)", .2, "rgb(170,219,250)", 1, "rgb(110,192,255)", 5, "rgb(66,170,255)", 10, "rgb(0,149,255)", 20, "rgb(0,115,255)", 30, "rgb(0,76,255)", 40, "rgb(0,26,255)", 50, "rgb(77,26,255)", 75, "rgb(122,0,245)", 100, "rgb(171,0,245)", 150, "rgb(196,0,245)", 200, "rgb(245,0,245)", 1e3, "rgb(245,0,245)"], Vent: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgb(18,244,244)", 1, "rgb(8,159,252)", 5, "rgb(14,81,248)", 10, "rgb(16,13,112)", 20, "rgb(95,255,0)", 30, "rgb(1,206,63)", 40, "rgb(56,144,0)", 50, "rgb(32,95,1)", 60, "rgb(255,255,0)", 70, "rgb(255,235,0)", 80, "rgb(255,170,0)", 90, "rgb(230,76,0)", 100, "rgb(255,0,0)", 125, "rgb(255,0,0)", 150, "rgb(122,0,245)", 200, "rgb(51,51,51)"], Temperatura: ["interpolate", ["exponential", 1], ["number", ["get", e]], -30, "rgb(109,0,109)", -25, "rgb(127,0,127)", -23, "rgb(149,0,149)", -21, "rgb(170,0,170)", -19, "rgb(200,0,200)", -15, "rgb(226,0,226)", -13, "rgb(68,22,171)", -11, "rgb(61,12,199)", -9, "rgb(65,8,255)", -7, "rgb(3,82,230)", -5, "rgb(3,113,230)", -3, "rgb(19,144,230)", -1, "rgb(46,182,230)", 1, "rgb(88,219,230)", 3, "rgb(37,157,0)", 5, "rgb(64,170,0)", 7, "rgb(87,183,0)", 9, "rgb(131,207,0)", 11, "rgb(164,225,5)", 13, "rgb(191,242,9)", 15, "rgb(215,252,25)", 17, "rgb(253,255,2)", 19, "rgb(255,232,2)", 21, "rgb(255,206,9)", 23, "rgb(250,173,0)", 25, "rgb(252,142,0)", 28, "rgb(246,116,0)", 31, "rgb(255,90,0)", 33, "rgb(255,60,0)", 35, "rgb(245,1,47)", 37, "rgb(219,1,42)", 39, "rgb(198,1,38)", 42, "rgb(170,1,33)", 44, "rgb(138,17,32)", 46, "rgb(105,17,32)", 48, "rgb(78,0,32)", 50, "rgb(65,0,27)", 52, "rgb(48,0,9)"], TemperaturaXafogor: ["interpolate", ["exponential", 1], ["number", ["get", e]], 20, "rgba(255,255,255,0.3)", 21, "rgb(250,173,0)", 23, "rgb(252,142,0)", 25, "rgb(246,116,0)", 28, "rgb(255,90,0)", 31, "rgb(255,60,0)", 33, "rgb(245,1,47)", 35, "rgb(219,1,42)", 37, "rgb(198,1,38)", 39, "rgb(170,1,33)", 42, "rgb(138,17,32)", 44, "rgb(105,17,32)", 46, "rgb(78,0,32)", 48, "rgb(65,0,27)", 50, "rgb(48,0,9)", 52, "rgb(255,255,255)"], TemperaturaSensacio: ["interpolate", ["exponential", 1], ["number", ["get", e]], -30, "rgb(109,0,109)", -25, "rgb(127,0,127)", -23, "rgb(149,0,149)", -21, "rgb(170,0,170)", -19, "rgb(200,0,200)", -15, "rgb(226,0,226)", -13, "rgb(68,22,171)", -11, "rgb(61,12,199)", -9, "rgb(65,8,255)", -7, "rgb(3,82,230)", -5, "rgb(3,113,230)", -3, "rgb(19,144,230)", -1, "rgb(46,182,230)", 1, "rgb(88,219,230)", 3, "rgb(37,157,0)", 5, "rgb(64,170,0)", 7, "rgb(87,183,0)", 9, "rgb(131,207,0)"], ComparativaTemperatura: ["interpolate", ["exponential", 1], ["number", ["get", e]], -20, "rgb(184,192,195)", -18, "rgb(158,151,171)", -16, "rgb(129,102,141)", -15, "rgb(106,68,119)", -14, "rgb(109,0,109)", -13, "rgb(127,0,127)", -12, "rgb(149,0,149)", -11, "rgb(170,0,170)", -10, "rgb(200,0,200)", -9, "rgb(226,0,226)", -8, "rgb(68,22,171)", -7, "rgb(61,12,199)", -6, "rgb(65,8,255)", -5, "rgb(3,82,230)", -4, "rgb(3,113,230)", -3, "rgb(19,144,230)", -2, "rgb(46,182,230)", -1, "rgb(88,219,230)", 0, "rgb(253,255,209)", 1, "rgb(250,253,153)", 2, "rgb(243,249,79)", 3, "rgb(253,255,2)", 4, "rgb(255,232,2)", 5, "rgb(255,206,9)", 6, "rgb(250,173,0)", 7, "rgb(252,142,0)", 8, "rgb(246,116,0)", 9, "rgb(255,90,0)", 10, "rgb(255,60,0)", 11, "rgb(245,1,47)", 12, "rgb(219,1,42)", 13, "rgb(198,1,38)", 14, "rgb(170,1,33)", 15, "rgb(138,17,32)", 16, "rgb(105,17,32)", 18, "rgb(78,0,32)", 20, "rgb(65,0,27)"], AmplitudTermica: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgb(109,0,109)", 1, "rgb(127,0,127)", 3, "rgb(149,0,149)", 5, "rgb(170,0,170)", 7, "rgb(200,0,200)", 9, "rgb(226,0,226)", 11, "rgb(68,22,171)", 13, "rgb(61,12,199)", 15, "rgb(65,8,255)", 17, "rgb(3,82,230)", 19, "rgb(3,113,230)", 21, "rgb(19,144,230)", 23, "rgb(46,182,230)", 25, "rgb(88,219,230)", 28, "rgb(37,157,0)", 31, "rgb(64,170,0)", 33, "rgb(87,183,0)", 35, "rgb(131,207,0)", 37, "rgb(164,225,5)", 39, "rgb(191,242,9)", 42, "rgb(215,252,25)", 44, "rgb(253,255,2)", 46, "rgb(255,232,2)", 48, "rgb(255,206,9)", 50, "rgb(250,173,0)", 52, "rgb(252,142,0)"], Humitat: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgba(255,255,255,0.3)", 20, "rgba(255,255,255,0.3)", 30, "rgb(255,51,51)", 40, "rgb(255,153,51)", 50, "rgb(255,255,0)", 55, "rgb(128,255,64)", 60, "rgb(0,255,176)", 65, "rgb(0,255,255)", 70, "rgb(0,228,248)", 75, "rgb(0,200,240)", 80, "rgb(0,116,216)", 95, "rgb(0,0,192)", 100, "rgb(50,50,50)"], CotaNeu: ["interpolate", ["exponential", 1], ["number", ["get", e]], 100, "rgb(0,0,192)", 200, "rgb(0,60,200)", 300, "rgb(0,88,208)", 400, "rgb(0,116,216)", 500, "rgb(0,144,224)", 600, "rgb(0,172,232)", 700, "rgb(0,200,240)", 800, "rgb(0,228,248)", 900, "rgb(0,255,255)", 1e3, "rgb(0,255,176)", 1100, "rgb(128,255,64)", 1200, "rgb(192,255,0)", 1300, "rgb(255,255,0)", 1400, "rgb(255,236,0)", 1500, "rgb(255,216,0)", 1600, "rgb(255,196,0)", 1700, "rgb(255,176,0)", 1800, "rgb(255,156,0)", 1900, "rgb(255,136,0)", 2e3, "rgb(255,112,0)", 2100, "rgb(255,80,0)", 2200, "rgb(255,0,0)", 2300, "rgb(240,0,48)", 2400, "rgb(224,0,72)", 2500, "rgb(208,0,96)", 2600, "rgb(192,0,120)", 2700, "rgb(208,0,144)", 2800, "rgb(224,0,168)", 2900, "rgb(240,0,192)", 3e3, "rgb(255,0,216)", 3100, "rgb(255,64,255)", 3200, "rgb(255,104,255)"], PlujaHora: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgba(255,255,255,0.3)", .1, "rgb(170,255,255)", .5, "rgb(83,210,255)", 1, "rgb(42,170,255)", 2, "rgb(28,126,217)", 3, "rgb(14,63,217)", 4, "rgb(75,25,75)", 6, "rgb(153,51,153)", 10, "rgb(210,0,210)", 20, "rgb(255,0,255)"], PlujaDia: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgba(255,255,255,0.3)", 1, "rgb(170,255,255)", 2, "rgb(83,210,255)", 3, "rgb(42,170,255)", 4, "rgb(28,126,217)", 6, "rgb(14,63,217)", 10, "rgb(75,25,75)", 20, "rgb(153,51,153)", 50, "rgb(210,0,210)", 100, "rgb(255,0,255)"], PlujaMes: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgba(255,255,255,0.3)", 5, "rgb(170,255,255)", 10, "rgb(83,210,255)", 20, "rgb(42,170,255)", 30, "rgb(28,126,217)", 40, "rgb(14,63,217)", 60, "rgb(75,25,75)", 100, "rgb(153,51,153)", 200, "rgb(210,0,210)", 250, "rgb(255,0,255)"], PlujaAny: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgba(255,255,255,0.3)", 200, "rgb(170,255,255)", 300, "rgb(83,210,255)", 400, "rgb(42,170,255)", 500, "rgb(28,126,217)", 600, "rgb(14,63,217)", 700, "rgb(75,25,75)", 800, "rgb(153,51,153)", 900, "rgb(210,0,210)", 1200, "rgb(255,0,255)"], NeuHora: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgba(255,255,255,0.3)", .1, "rgb(0,255,0)", .5, "rgb(127,255,0)", 1, "rgb(76,187,23)", 2, "rgb(80,200,120)", 3, "rgb(0,168,107)", 4, "rgb(64,130,109)", 6, "rgb(68,148,74)", 10, "rgb(123,160,91)", 20, "rgb(107,142,35)"], NeuDia: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgba(255,255,255,0.3)", 1, "rgb(0,255,0)", 2, "rgb(127,255,0)", 3, "rgb(76,187,23)", 4, "rgb(80,200,120)", 6, "rgb(0,168,107)", 10, "rgb(64,130,109)", 20, "rgb(68,148,74)", 50, "rgb(123,160,91)", 100, "rgb(107,142,35)"], NeuMes: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgba(255,255,255,0.3)", 5, "rgb(0,255,0)", 10, "rgb(127,255,0)", 20, "rgb(76,187,23)", 30, "rgb(80,200,120)", 40, "rgb(0,168,107)", 60, "rgb(64,130,109)", 100, "rgb(68,148,74)", 200, "rgb(123,160,91)", 250, "rgb(107,142,35)"], NeuAny: ["interpolate", ["exponential", 1], ["number", ["get", e]], 0, "rgba(255,255,255,0.3)", 200, "rgb(0,255,0)", 300, "rgb(127,255,0)", 400, "rgb(76,187,23)", 500, "rgb(80,200,120)", 600, "rgb(0,168,107)", 700, "rgb(64,130,109)", 800, "rgb(68,148,74)", 900, "rgb(123,160,91)", 1200, "rgb(107,142,35)"] },
            g = t.TemperaturaMeteocat;return Object.keys(t).forEach(function (e, o) {
          e === r && (g = t[e]);
        }), g;
      }, MapStyle.prototype.setStylesPaintFromColorArray = function (e, r, t) {
        void 0 === t && (t = !1);var g = this.colorizator._checkNumRangs(r.length - 1);return this._generateStylesfromRanges(e, g, r, t);
      }, MapStyle.prototype.setStylesPaintFromRanges = function (e, r, t, g) {
        void 0 === g && (g = !1), r = this.colorizator._checkNumRangs(r);var o = this.colorizator.getColorArrayfromSelectedBrewer(r + 1, t);return this._generateStylesfromRanges(e, r, o, g);
      }, MapStyle.prototype.setStylebyFactorHeights = function (e, r) {
        return r = r || this.defaultHFactor, ["*", ["number", ["get", e]], r];
      }, MapStyle.prototype._checkDuplicates = function (e) {
        var r = !1,
            t = {};e.forEach(function (e) {
          t[e] || (t[e] = 0), t[e] += 1;
        });for (var g in t) {
          t[g] >= 2 && (r = !0);
        }return r;
      }, MapStyle.prototype._generateStylesfromRanges = function (e, r, t, g) {
        var o = this;if (this.generateGeoStatisticsFromField(e)) {
          var i = this.geostatstics.getStatsFromRangesColorsGeoJSON(r, t),
              b = ["step", ["get", e]],
              a = ["step", ["get", e]];try {
            if (i.classification.jenks.length <= 2 || i.classification.uniques.length <= 2) b = [], b = t[0], a = [], a = t[0];else {
              var n = i.classification.jenks;this._checkDuplicates(i.classification.jenks) && (n = i.classification.equals), n.forEach(function (e, r) {
                var t = i.colors.colors[r];e && t && (b.push(t, e), a.push(o.colorizator.getOppositeGrayScaleColor(t), e));
              }), b.push(t[t.length - 1]), a.push("rgba(0,0,0,0)");
            }
          } catch (e) {
            b = t[0], a = t[0];
          }return this.legendColors = i.colors.colors, this.legendRanges = i.classification.jenks, this.haloTextColors = a, g ? a : b;
        }throw new Error("No geostatistics created");
      }, MapStyle.prototype.getFieldType = function (e) {
        var r = this;if (null !== this.fieldNames) for (var t = 0; t < this.fieldNames.length; t++) {
          if (r.fieldNames[t].name === e) return r.fieldNames[t].type;
        }return null;
      }, MapStyle.prototype.getExtendFromGeoJSON = function () {
        return this.geoExtent = new GeoExtent(this.geoJSON), this.geoExtent;
      }, MapStyle.prototype.getHaloStyleColors = function () {
        return this.haloTextColors;
      }, MapStyle.prototype.setStylePaintFromUniquesValues = function (e, r, t) {
        var g = this,
            o = this.getFieldType(e) || "string";if (this.generateGeoStatisticsFromField(e)) {
          var i = this.geostatstics.getUniqueValues(),
              b = this.colorizator.getColorsScaleRanges(i.length, r, t),
              a = ["match", ["get", e]],
              n = ["match", ["get", e]],
              l = [];return i.forEach(function (e, r) {
            "string" === o && (e = e.replace("# ", "")), a.push(e, b[r]), n.push(e, g.colorizator.getOppositeGrayScaleColor(b[r])), l.push(e);
          }), a.push(b[b.length - 1]), n.push("rgba(0,0,0,0)"), this.haloTextColors = n, this.legendColors = b, this.legendRanges = l, a;
        }throw new Error("No geostatistics created");
      }, module.exports = MapStyle;
    }, { "../color/colorizator": 29, "../geo/bridgeStatics": 31, "../geo/geoJSONStatics": 33, "../geo/utilsStatics": 34, "@mapbox/geojson-extent": 4, "then-request": 17 }], 38: [function (_dereq_, module, exports) {
      "use strict";
      !function (t) {
        var s;"object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = t() : "function" == typeof s && s.amd ? s(t) : geostats = t();
      }(function () {
        var t = function t(_t) {
          return "number" == typeof _t && parseFloat(_t) == parseInt(_t, 10) && !isNaN(_t);
        },
            s = function s(t) {
          return t;
        },
            i = function i(t) {
          return !isNaN(parseFloat(t)) && isFinite(t);
        };return Array.prototype.indexOf || (Array.prototype.indexOf = function (t, s) {
          var i = this;if (void 0 === this || null === this) throw new TypeError('"this" is null or not defined');var e = this.length >>> 0;for (s = +s || 0, Math.abs(s) === 1 / 0 && (s = 0), s < 0 && (s += e) < 0 && (s = 0); s < e; s++) {
            if (i[s] === t) return s;
          }return -1;
        }), function (e) {
          this.objectID = "", this.separator = " - ", this.legendSeparator = this.separator, this.method = "", this.precision = 0, this.precisionflag = "auto", this.roundlength = 2, this.is_uniqueValues = !1, this.debug = !1, this.silent = !0, this.bounds = Array(), this.ranges = Array(), this.inner_ranges = null, this.colors = Array(), this.counter = Array(), this.stat_sorted = null, this.stat_mean = null, this.stat_median = null, this.stat_sum = null, this.stat_max = null, this.stat_min = null, this.stat_pop = null, this.stat_variance = null, this.stat_stddev = null, this.stat_cov = null, this.log = function (t, s) {
            this.debug;
          }, this.setBounds = function (t) {
            this.bounds = Array(), this.bounds = t;
          }, this.setSerie = function (t) {
            this.serie = Array(), this.serie = t, this.resetStatistics(), this.setPrecision();
          }, this.setColors = function (t) {
            this.log("Setting color ramp (" + t.length + ") : " + t.join()), this.colors = t;
          }, this.doCount = function () {
            var t = this;if (!this._nodata()) {
              var s = this.sorted();this.counter = new Array();for (var i = 0; i < this.bounds.length - 1; i++) {
                t.counter[i] = 0;
              }for (j = 0; j < s.length; j++) {
                var e = t.getClass(s[j]);t.counter[e]++;
              }
            }
          }, this.setPrecision = function (t) {
            var s = this;if (void 0 !== t && (this.precisionflag = "manual", this.precision = t), "auto" == this.precisionflag) for (var i = 0; i < this.serie.length; i++) {
              if (isNaN("" + s.serie[i]) || -1 == ("" + s.serie[i]).toString().indexOf(".")) var e = 0;else var e = ("" + s.serie[i]).split(".")[1].length;e > s.precision && (s.precision = e);
            }this.precision > 20 && (this.precision = 20), this.serie = this.decimalFormat(this.serie);
          }, this.decimalFormat = function (t) {
            for (var s = this, e = new Array(), n = 0; n < t.length; n++) {
              i(t[n]) ? e[n] = parseFloat(parseFloat(t[n]).toFixed(s.precision)) : e[n] = t[n];
            }return e;
          }, this.setRanges = function () {
            var t = this;this.ranges = Array();for (var s = 0; s < this.bounds.length - 1; s++) {
              t.ranges[s] = t.bounds[s] + t.separator + t.bounds[s + 1];
            }
          }, this.min = function () {
            var t = this;if (!this._nodata()) {
              this.stat_min = this.serie[0];for (var s = 0; s < this.pop(); s++) {
                t.serie[s] < t.stat_min && (t.stat_min = t.serie[s]);
              }return this.stat_min;
            }
          }, this.max = function () {
            var t = this;if (!this._nodata()) {
              this.stat_max = this.serie[0];for (var s = 0; s < this.pop(); s++) {
                t.serie[s] > t.stat_max && (t.stat_max = t.serie[s]);
              }return this.stat_max;
            }
          }, this.sum = function () {
            var t = this;if (!this._nodata()) {
              if (null == this.stat_sum) {
                this.stat_sum = 0;for (var s = 0; s < this.pop(); s++) {
                  t.stat_sum += parseFloat(t.serie[s]);
                }
              }return this.stat_sum;
            }
          }, this.pop = function () {
            if (!this._nodata()) return null == this.stat_pop && (this.stat_pop = this.serie.length), this.stat_pop;
          }, this.mean = function () {
            if (!this._nodata()) return null == this.stat_mean && (this.stat_mean = parseFloat(this.sum() / this.pop())), this.stat_mean;
          }, this.median = function () {
            if (!this._nodata()) {
              if (null == this.stat_median) {
                this.stat_median = 0;var t = this.sorted();t.length % 2 ? this.stat_median = parseFloat(t[Math.ceil(t.length / 2) - 1]) : this.stat_median = (parseFloat(t[t.length / 2 - 1]) + parseFloat(t[t.length / 2])) / 2;
              }return this.stat_median;
            }
          }, this.variance = function () {
            var t = this;if (!this._nodata()) {
              if (null == this.stat_variance) {
                for (var s = 0, i = this.mean(), e = 0; e < this.pop(); e++) {
                  s += Math.pow(t.serie[e] - i, 2);
                }this.stat_variance = s / this.pop(), this.stat_variance = Math.round(this.stat_variance * Math.pow(10, this.roundlength)) / Math.pow(10, this.roundlength);
              }return this.stat_variance;
            }
          }, this.stddev = function () {
            if (!this._nodata()) return null == this.stat_stddev && (this.stat_stddev = Math.sqrt(this.variance()), this.stat_stddev = Math.round(this.stat_stddev * Math.pow(10, this.roundlength)) / Math.pow(10, this.roundlength)), this.stat_stddev;
          }, this.cov = function (t) {
            if (!this._nodata()) return null == this.stat_cov && (this.stat_cov = this.stddev() / this.mean(), this.stat_cov = Math.round(this.stat_cov * Math.pow(10, this.roundlength)) / Math.pow(10, this.roundlength)), this.stat_cov;
          }, this.resetStatistics = function () {
            this.stat_sorted = null, this.stat_mean = null, this.stat_median = null, this.stat_sum = null, this.stat_max = null, this.stat_min = null, this.stat_pop = null, this.stat_variance = null, this.stat_stddev = null, this.stat_cov = null;
          }, this._nodata = function () {
            return 0 == this.serie.length ? 1 : 0;
          }, this._hasNegativeValue = function () {
            for (var t = this, s = 0; s < this.serie.length; s++) {
              if (t.serie[s] < 0) return !0;
            }return !1;
          }, this._hasZeroValue = function () {
            for (var t = this, s = 0; s < this.serie.length; s++) {
              if (0 === parseFloat(t.serie[s])) return !0;
            }return !1;
          }, this.sorted = function () {
            return null == this.stat_sorted && (0 == this.is_uniqueValues ? this.stat_sorted = this.serie.sort(function (t, s) {
              return t - s;
            }) : this.stat_sorted = this.serie.sort(function (t, s) {
              var i = t.toString().toLowerCase(),
                  e = s.toString().toLowerCase();return i < e ? -1 : i > e ? 1 : 0;
            })), this.stat_sorted;
          }, this.info = function () {
            if (!this._nodata()) {
              var t = "";return t += s("Population") + " : " + this.pop() + " - [" + s("Min") + " : " + this.min() + " | " + s("Max") + " : " + this.max() + "]\n", t += s("Mean") + " : " + this.mean() + " - " + s("Median") + " : " + this.median() + "\n", t += s("Variance") + " : " + this.variance() + " - " + s("Standard deviation") + " : " + this.stddev() + " - " + s("Coefficient of variation") + " : " + this.cov() + "\n";
            }
          }, this.setClassManually = function (t) {
            if (!this._nodata()) {
              if (t[0] === this.min() && t[t.length - 1] === this.max()) return this.setBounds(t), this.setRanges(), this.method = s("manual classification") + " (" + (t.length - 1) + " " + s("classes") + ")", this.bounds;if (!this.silent) throw new TypeError(s("Given bounds may not be correct! please check your input.\nMin value : " + this.min() + " / Max value : " + this.max()));
            }
          }, this.getClassEqInterval = function (t, i, e) {
            if (!this._nodata()) {
              for (var n = void 0 === i ? this.min() : i, a = void 0 === e ? this.max() : e, r = Array(), o = n, h = (a - n) / t, l = 0; l <= t; l++) {
                r[l] = o, o += h;
              }return r[t] = a, this.setBounds(r), this.setRanges(), this.method = s("eq. intervals") + " (" + t + " " + s("classes") + ")", this.bounds;
            }
          }, this.getQuantiles = function (t) {
            for (var s = this.sorted(), i = [], e = this.pop() / t, n = 1; n < t; n++) {
              var a = Math.round(n * e + .49);i.push(s[a - 1]);
            }return i;
          }, this.getClassQuantile = function (t) {
            if (!this._nodata()) {
              var i = this.sorted(),
                  e = this.getQuantiles(t);return e.unshift(i[0]), e[i.length - 1] !== i[i.length - 1] && e.push(i[i.length - 1]), this.setBounds(e), this.setRanges(), this.method = s("quantile") + " (" + t + " " + s("classes") + ")", this.bounds;
            }
          }, this.getClassStdDeviation = function (t, i) {
            var e = this;if (!this._nodata()) {
              var n = (this.max(), this.min(), Array());if (t % 2 == 1) {
                var a = Math.floor(t / 2),
                    r = a + 1;n[a] = this.mean() - this.stddev() / 2, n[r] = this.mean() + this.stddev() / 2;for (var o = a - 1; o > 0; o--) {
                  var h = n[o + 1] - e.stddev();n[o] = h;
                }for (var o = r + 1; o < t; o++) {
                  var h = n[o - 1] + e.stddev();n[o] = h;
                }
              } else {
                var l = t / 2;n[l] = this.mean();for (var o = l - 1; o > 0; o--) {
                  var h = n[o + 1] - e.stddev();n[o] = h;
                }for (var o = l + 1; o < t; o++) {
                  var h = n[o - 1] + e.stddev();n[o] = h;
                }
              }return n[0] = void 0 === i ? n[1] - this.stddev() : this.min(), n[t] = void 0 === i ? n[t - 1] + this.stddev() : this.max(), this.setBounds(n), this.setRanges(), this.method = s("std deviation") + " (" + t + " " + s("classes") + ")", this.bounds;
            }
          }, this.getClassGeometricProgression = function (t) {
            if (!this._nodata()) {
              if (!this._hasNegativeValue() && !this._hasZeroValue()) {
                for (var i = Array(), e = this.min(), n = this.max(), a = Math.log(n) / Math.LN10, r = Math.log(e) / Math.LN10, o = (a - r) / t, h = 0; h < t; h++) {
                  i[h] = 0 == h ? r : i[h - 1] + o;
                }return i = i.map(function (t) {
                  return Math.pow(10, t);
                }), i.push(this.max()), this.setBounds(i), this.setRanges(), this.method = s("geometric progression") + " (" + t + " " + s("classes") + ")", this.bounds;
              }if (!this.silent) throw new TypeError(s("geometric progression can't be applied with a serie containing negative or zero values."));
            }
          }, this.getClassArithmeticProgression = function (t) {
            if (!this._nodata()) {
              for (var i = 0, e = 1; e <= t; e++) {
                i += e;
              }for (var n = Array(), a = this.min(), r = this.max(), o = (r - a) / i, e = 0; e <= t; e++) {
                n[e] = 0 == e ? a : n[e - 1] + e * o;
              }return this.setBounds(n), this.setRanges(), this.method = s("arithmetic progression") + " (" + t + " " + s("classes") + ")", this.bounds;
            }
          }, this.getClassJenks = function (t) {
            if (!this._nodata()) {
              dataList = this.sorted();for (var i = [], e = 0, n = dataList.length + 1; e < n; e++) {
                for (var a = [], r = 0, o = t + 1; r < o; r++) {
                  a.push(0);
                }i.push(a);
              }for (var h = [], l = 0, u = dataList.length + 1; l < u; l++) {
                for (var d = [], c = 0, f = t + 1; c < f; c++) {
                  d.push(0);
                }h.push(d);
              }for (var g = 1, v = t + 1; g < v; g++) {
                i[0][g] = 1, h[0][g] = 0;for (var p = 1, m = dataList.length + 1; p < m; p++) {
                  h[p][g] = 1 / 0;
                }var _ = 0;
              }for (var b = 2, y = dataList.length + 1; b < y; b++) {
                for (var x = 0, F = 0, M = 0, w = 1, C = b + 1; w < C; w++) {
                  var A = b - w + 1,
                      L = parseFloat(dataList[A - 1]);F += L * L, x += L, M += 1, _ = F - x * x / M;var S = A - 1;if (0 != S) for (var q = 2, V = t + 1; q < V; q++) {
                    h[b][q] >= _ + h[S][q - 1] && (i[b][q] = A, h[b][q] = _ + h[S][q - 1]);
                  }
                }i[b][1] = 1, h[b][1] = _;
              }for (var E = dataList.length, R = [], l = 0; l <= t; l++) {
                R.push(0);
              }R[t] = parseFloat(dataList[dataList.length - 1]), R[0] = parseFloat(dataList[0]);for (var I = t; I >= 2;) {
                var N = parseInt(i[E][I] - 2);R[I - 1] = dataList[N], E = parseInt(i[E][I] - 1), I -= 1;
              }return R[0] == R[1] && (R[0] = 0), this.setBounds(R), this.setRanges(), this.method = s("Jenks") + " (" + t + " " + s("classes") + ")", this.bounds;
            }
          }, this.getClassUniqueValues = function () {
            if (!this._nodata()) {
              this.is_uniqueValues = !0;for (var t = this.sorted(), i = Array(), e = 0; e < this.pop(); e++) {
                -1 === i.indexOf(t[e]) && i.push(t[e]);
              }return this.bounds = i, this.method = s("unique values"), i;
            }
          }, this.getClass = function (t) {
            for (var i = this, e = 0; e < this.bounds.length; e++) {
              if (1 == i.is_uniqueValues) {
                if (t == i.bounds[e]) return e;
              } else if (parseFloat(t) <= i.bounds[e + 1]) return e;
            }return s("Unable to get value's class.");
          }, this.getRanges = function () {
            return this.ranges;
          }, this.getRangeNum = function (t) {
            for (var s, i, e = this, i = 0; i < this.ranges.length; i++) {
              if (s = e.ranges[i].split(/ - /), t <= parseFloat(s[1])) return i;
            }
          }, this.getInnerRanges = function () {
            var t = this;if (null != this.inner_ranges) return this.inner_ranges;for (var s = new Array(), i = this.sorted(), e = 1, n = 0; n < i.length; n++) {
              if (0 == n) var a = i[n];if (parseFloat(i[n]) > parseFloat(t.bounds[e])) {
                s[e - 1] = "" + a + t.separator + i[n - 1];var a = i[n];e++;
              }if (e == t.bounds.length - 1) return s[e - 1] = "" + a + t.separator + i[i.length - 1], t.inner_ranges = s, t.inner_ranges;
            }
          }, this.getSortedlist = function () {
            return this.sorted().join(", ");
          }, this.getHtmlLegend = function (i, e, n, a, r, o) {
            var h = this,
                l = "",
                u = new Array();if (this.doCount(), ccolors = null != i ? i : this.colors, lg = null != e ? e : "Legend", getcounter = null != n, fn = null != a ? a : function (t) {
              return t;
            }, null == r && (r = "default"), "discontinuous" != r || (this.getInnerRanges(), -1 === this.counter.indexOf(0))) {
              if ("DESC" !== o && (o = "ASC"), !(ccolors.length < this.ranges.length)) {
                if (0 == this.is_uniqueValues) for (var d = 0; d < this.ranges.length; d++) {
                  !0 === getcounter && (l = ' <span class="geostats-legend-counter">(' + h.counter[d] + ")</span>");var c = h.ranges[d].split(h.separator),
                      f = parseFloat(c[0]).toFixed(h.precision),
                      g = parseFloat(c[1]).toFixed(h.precision);if ("distinct" == r && 0 != d && (t(f) ? (f = parseInt(f) + 1, "manual" == h.precisionflag && 0 != h.precision && (f = parseFloat(f).toFixed(h.precision))) : (f = parseFloat(f) + 1 / Math.pow(10, h.precision), f = parseFloat(f).toFixed(h.precision))), "discontinuous" == r) var c = h.inner_ranges[d].split(h.separator),
                      f = parseFloat(c[0]).toFixed(h.precision),
                      g = parseFloat(c[1]).toFixed(h.precision);var v = fn(f) + h.legendSeparator + fn(g),
                      p = '<div><div class="geostats-legend-block" style="background-color:' + ccolors[d] + '"></div> ' + v + l + "</div>";u.push(p);
                } else for (var d = 0; d < this.bounds.length; d++) {
                  !0 === getcounter && (l = ' <span class="geostats-legend-counter">(' + h.counter[d] + ")</span>");var v = fn(h.bounds[d]),
                      p = '<div><div class="geostats-legend-block" style="background-color:' + ccolors[d] + '"></div> ' + v + l + "</div>";u.push(p);
                }"DESC" === o && u.reverse();for (var m = '<div class="geostats-legend"><div class="geostats-legend-title">' + s(lg) + "</div>", d = 0; d < u.length; d++) {
                  m += u[d];
                }return m += "</div>";
              }if (!this.silent) throw new TypeError(s("The number of colors should fit the number of ranges. Exit!"));
            } else if (!this.silent) throw new TypeError(s("Geostats cannot apply 'discontinuous' mode to the getHtmlLegend() method because some classes are not populated.\nPlease switch to 'default' or 'distinct' modes. Exit!"));
          }, this.objectID = new Date().getUTCMilliseconds(), void 0 !== e && e.length > 0 ? (this.serie = e, this.setPrecision(), this.log("Setting serie (" + e.length + ") : " + e.join())) : this.serie = Array(), this.getJenks = this.getClassJenks, this.getGeometricProgression = this.getClassGeometricProgression, this.getEqInterval = this.getClassEqInterval, this.getQuantile = this.getClassQuantile, this.getStdDeviation = this.getClassStdDeviation, this.getUniqueValues = this.getClassUniqueValues, this.getArithmeticProgression = this.getClassArithmeticProgression;
        };
      });
    }, {}] }, {}, [35])(35);
});

//# sourceMappingURL=mapstylergl.js.map
